// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* src/components/Person/PersonEditPage.css */
/* Same design as WizardAddPerson - single page edition */

/* ===================== FULL PAGE LAYOUT ===================== */
/* Covers only the lanes area - sidebar, tabs and scenario header remain visible */

.person-edit-page {
  position: fixed;
  top: 120px;  /* Below: tabs (~50px) + scenario header (~70px) */
  left: 230px;  /* After sidebar (220px) + small gap (10px) */
  right: 10px;  /* Small margin */
  bottom: 10px;  /* Small margin */
  display: flex;
  flex-direction: column;
  background: #F8FAFC;
  z-index: 1100;  /* Above the App save button (z-index: 1000) */
  overflow: hidden;
  border-radius: 10px;  /* Match lanes border-radius */
  border: 1px solid #BDC3C7;  /* Match lanes border */
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.15);
}

@media (max-width: 768px) {
  .person-edit-page {
    left: 8px;
    right: 8px;
    top: 120px;
    bottom: 8px;
  }
}

/* Standalone mode - full page */
.person-edit-page.standalone {
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  border-radius: 0;
  border: none;
}

.edit-loading {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
  font-size: 16px;
  color: #64748B;
}

/* ===================== TOPBAR ===================== */

.person-edit-page .edit-topbar {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 12px 24px;
  background: linear-gradient(135deg, #FF6F61 0%, #FF8A80 100%);
  color: white;
  flex-shrink: 0;
}

.person-edit-page .topbar-left {
  display: flex;
  align-items: center;
  gap: 12px;
}

.person-edit-page .topbar-left h3 {
  margin: 0;
  font-size: 16px;
  font-weight: 600;
}

.person-edit-page .standalone-badge {
  background: rgba(255,255,255,0.2);
  padding: 4px 10px;
  border-radius: 12px;
  font-size: 11px;
  font-weight: 500;
}

.person-edit-page .topbar-right {
  display: flex;
  align-items: center;
  gap: 10px;
}

.person-edit-page .save-btn {
  padding: 8px 20px;
  background: rgba(255,255,255,0.2);
  border: 1px solid rgba(255,255,255,0.4);
  color: white;
  border-radius: 6px;
  font-size: 13px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.2s ease;
  min-width: 110px;
}

.person-edit-page .save-btn:hover:not(:disabled) {
  background: rgba(255,255,255,0.35);
  transform: translateY(-1px);
}

.person-edit-page .save-btn:disabled {
  cursor: wait;
  opacity: 0.7;
}

/* Saving state - subtle pulse animation */
.person-edit-page .save-btn.saving {
  background: rgba(255,255,255,0.15);
  animation: savingPulse 1s ease-in-out infinite;
}

@keyframes savingPulse {
  0%, 100% { opacity: 0.7; }
  50% { opacity: 1; }
}

/* Success state - brief green flash */
.person-edit-page .save-btn.success {
  background: rgba(16, 185, 129, 0.7);
  border-color: rgba(16, 185, 129, 0.9);
  animation: successFlash 0.4s ease-out;
}

@keyframes successFlash {
  0% { transform: scale(1); box-shadow: 0 0 0 0 rgba(16, 185, 129, 0.6); }
  50% { transform: scale(1.05); box-shadow: 0 0 20px 4px rgba(16, 185, 129, 0.4); }
  100% { transform: scale(1); box-shadow: 0 0 0 0 rgba(16, 185, 129, 0); }
}

.person-edit-page .close-btn {
  background: rgba(255, 255, 255, 0.2);
  border: none;
  font-size: 18px;
  cursor: pointer;
  color: white;
  width: 28px;
  height: 28px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: background 0.2s;
}

.person-edit-page .close-btn:hover {
  background: rgba(255, 255, 255, 0.3);
}

/* ===================== PERSON HEADER ROW ===================== */
/* Two compact sections side by side */

.person-edit-page .person-header-row {
  display: grid;
  grid-template-columns: 1fr 2fr;
  gap: 16px;
}

.person-edit-page .form-section.compact {
  padding: 14px 16px;
}

.person-edit-page .form-section.compact h4 {
  margin: 0 0 10px 0;
  font-size: 13px;
  color: #64748B;
  font-weight: 600;
}

/* Family section layout */
.person-edit-page .family-row {
  display: flex;
  align-items: center;
  gap: 16px;
  flex-wrap: wrap;
}

/* Status chips - compact */
.person-edit-page .status-chips {
  display: flex;
  gap: 4px;
}

.person-edit-page .status-chip {
  width: 34px;
  height: 34px;
  border: 2px solid #E2E8F0;
  border-radius: 8px;
  background: white;
  cursor: pointer;
  transition: all 0.15s;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0;
}

.person-edit-page .status-chip .chip-icon {
  font-size: 16px;
}

.person-edit-page .status-chip:hover {
  border-color: #FF6F61;
  background: #FFF5F4;
}

.person-edit-page .status-chip.selected {
  border-color: #FF6F61;
  background: #FF6F61;
}

/* Children inline control */
.person-edit-page .children-inline {
  display: flex;
  align-items: center;
  gap: 6px;
}

.person-edit-page .children-inline .children-label {
  font-size: 12px;
  color: #64748B;
  font-weight: 500;
}

.person-edit-page .children-inline .child-btn {
  width: 26px;
  height: 26px;
  border: 1px solid #E2E8F0;
  border-radius: 6px;
  background: white;
  font-size: 14px;
  font-weight: 600;
  color: #64748B;
  cursor: pointer;
  transition: all 0.15s;
}

.person-edit-page .children-inline .child-btn:hover:not(:disabled) {
  border-color: #FF6F61;
  color: #FF6F61;
}

.person-edit-page .children-inline .child-btn:disabled {
  opacity: 0.4;
  cursor: not-allowed;
}

.person-edit-page .children-inline .child-count {
  font-size: 15px;
  font-weight: 600;
  min-width: 18px;
  text-align: center;
}

/* Single parent checkbox */
.person-edit-page .single-parent-check {
  display: flex;
  align-items: center;
  gap: 5px;
  font-size: 12px;
  color: #64748B;
  cursor: pointer;
}

.person-edit-page .single-parent-check input {
  width: 14px;
  height: 14px;
  accent-color: #FF6F61;
}

/* Fiscal badge */
.person-edit-page .fiscal-badge {
  display: flex;
  align-items: baseline;
  gap: 3px;
  padding: 5px 10px;
  background: linear-gradient(135deg, #FF6F61 0%, #FF8A80 100%);
  border-radius: 16px;
  color: white;
  margin-left: auto;
}

.person-edit-page .fiscal-badge .fiscal-value {
  font-size: 15px;
  font-weight: 700;
}

.person-edit-page .fiscal-badge .fiscal-unit {
  font-size: 10px;
  font-weight: 500;
  opacity: 0.9;
}

/* ===================== BODY ===================== */

.person-edit-page .edit-body {
  flex: 1 1;
  overflow-y: auto;
  padding: 16px 20px;
  display: grid;
  grid-template-columns: 1fr;
  gap: 16px;
  align-content: start;
}

/* ===================== FORM SECTIONS ===================== */

.person-edit-page .form-section {
  background: white;
  border-radius: 12px;
  padding: 20px;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.06);
}

.person-edit-page .form-section h4 {
  margin: 0 0 16px 0;
  font-size: 15px;
  font-weight: 600;
  color: #1E293B;
  display: flex;
  align-items: center;
  gap: 10px;
}

.person-edit-page .section-icon {
  width: 24px;
  height: 24px;
  border-radius: 50%;
  background: #FF6F61;
  color: white;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 12px;
  font-weight: 700;
}

/* Sections take full width in single-column layout */
.person-edit-page .form-section.incomes-section,
.person-edit-page .form-section.summary-section {
  /* Already full width in 1-column grid */
}

/* ===================== FORM ELEMENTS ===================== */

.person-edit-page .form-row {
  display: flex;
  gap: 16px;
  margin-bottom: 16px;
}

.person-edit-page .form-group {
  flex: 1 1;
}

.person-edit-page .form-group label {
  display: block;
  font-size: 12px;
  font-weight: 500;
  color: #64748B;
  margin-bottom: 6px;
}

.person-edit-page .form-group input[type="text"],
.person-edit-page .form-group input[type="number"] {
  width: 100%;
  padding: 10px 12px;
  border: 1px solid #E2E8F0;
  border-radius: 8px;
  font-size: 14px;
  transition: border-color 0.2s;
  box-sizing: border-box;
}

.person-edit-page .form-group input:focus {
  outline: none;
  border-color: #FF6F61;
}

/* ===================== STATUS CARDS ===================== */

.person-edit-page .status-cards {
  display: flex;
  gap: 8px;
  flex-wrap: wrap;
}

.person-edit-page .status-card {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 4px;
  padding: 12px 16px;
  border: 2px solid #E2E8F0;
  border-radius: 10px;
  cursor: pointer;
  transition: all 0.2s;
  min-width: 70px;
}

.person-edit-page .status-card:hover {
  border-color: #FF6F61;
  background: #FFF5F4;
}

.person-edit-page .status-card.selected {
  border-color: #FF6F61;
  background: #FF6F61;
  color: white;
}

.person-edit-page .status-card .status-icon {
  font-size: 20px;
}

.person-edit-page .status-card .status-label {
  font-size: 11px;
  font-weight: 500;
}

/* ===================== CHILDREN CONTROL ===================== */

.person-edit-page .children-control {
  display: flex;
  align-items: center;
  gap: 12px;
}

.person-edit-page .children-btn {
  width: 36px;
  height: 36px;
  border: 2px solid #E2E8F0;
  border-radius: 8px;
  background: white;
  font-size: 18px;
  font-weight: 600;
  color: #64748B;
  cursor: pointer;
  transition: all 0.2s;
}

.person-edit-page .children-btn:hover:not(:disabled) {
  border-color: #FF6F61;
  color: #FF6F61;
}

.person-edit-page .children-btn:disabled {
  opacity: 0.4;
  cursor: not-allowed;
}

.person-edit-page .children-count {
  font-size: 18px;
  font-weight: 600;
  min-width: 24px;
  text-align: center;
}

/* ===================== CHECKBOX ===================== */

.person-edit-page .checkbox-group {
  margin-top: 8px;
}

.person-edit-page .checkbox-label {
  display: flex;
  align-items: center;
  gap: 8px;
  cursor: pointer;
  font-size: 14px;
}

.person-edit-page .checkbox-label input[type="checkbox"] {
  width: 16px;
  height: 16px;
  accent-color: #FF6F61;
}

/* ===================== FISCAL PARTS DISPLAY ===================== */

.person-edit-page .fiscal-parts-display {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 12px 16px;
  background: #F1F5F9;
  border-radius: 8px;
  margin-top: 12px;
}

.person-edit-page .fiscal-parts-display .label {
  font-size: 13px;
  color: #64748B;
}

.person-edit-page .fiscal-parts-display .parts {
  font-size: 16px;
  font-weight: 700;
  color: #FF6F61;
}

/* ===================== INCOME ADD SECTION ===================== */

.person-edit-page .income-add-section {
  margin-bottom: 20px;
}

.person-edit-page .income-category-row {
  display: flex;
  align-items: center;
  gap: 12px;
  margin-bottom: 10px;
}

.person-edit-page .category-label {
  font-size: 12px;
  font-weight: 600;
  color: #64748B;
  min-width: 100px;
}

.person-edit-page .category-types {
  display: flex;
  gap: 6px;
  flex-wrap: wrap;
}

.person-edit-page .add-type-btn {
  display: flex;
  align-items: center;
  gap: 6px;
  padding: 6px 12px;
  border: 1px solid #E2E8F0;
  border-radius: 20px;
  background: white;
  cursor: pointer;
  transition: all 0.2s;
  font-size: 12px;
}

.person-edit-page .add-type-btn:hover {
  border-color: #94A3B8;
  background: #F8FAFC;
}

.person-edit-page .add-type-btn .btn-icon {
  width: 20px;
  height: 20px;
  border-radius: 50%;
  color: white;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 10px;
  font-weight: 700;
}

.person-edit-page .add-type-btn .btn-label {
  color: #475569;
  font-weight: 500;
}

/* ===================== INCOME SOURCES LIST ===================== */

.person-edit-page .income-sources-list {
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.person-edit-page .no-sources-hint {
  text-align: center;
  padding: 40px 20px;
  color: #94A3B8;
}

.person-edit-page .no-sources-hint p {
  margin: 0;
  font-size: 14px;
}

/* ===================== INCOME SOURCE CARD ===================== */

.person-edit-page .income-source-card {
  border: 1px solid #E2E8F0;
  border-radius: 10px;
  overflow: hidden;
  background: white;
}

.person-edit-page .income-source-card.expanded {
  border-color: #CBD5E1;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.04);
}

.person-edit-page .income-source-card.needs-dates {
  border-style: dashed;
}

.person-edit-page .source-header {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 12px 14px;
  background: #F8FAFC;
  cursor: pointer;
}

.person-edit-page .source-icon {
  width: 28px;
  height: 28px;
  border-radius: 6px;
  color: white;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 11px;
  font-weight: 700;
  flex-shrink: 0;
}

.person-edit-page .source-type {
  font-size: 13px;
  font-weight: 600;
  color: #334155;
  white-space: nowrap;
}

.person-edit-page .source-label-input {
  flex: 1 1;
  min-width: 100px;
  padding: 6px 10px;
  border: 1px solid #E2E8F0;
  border-radius: 6px;
  font-size: 12px;
  background: white;
}

.person-edit-page .source-label-input:focus {
  outline: none;
  border-color: #FF6F61;
}

.person-edit-page .date-sep {
  font-size: 11px;
  color: #94A3B8;
}

.person-edit-page .source-date {
  padding: 5px 8px;
  border: 1px solid #E2E8F0;
  border-radius: 6px;
  font-size: 12px;
  background: white;
  cursor: pointer;
}

.person-edit-page .source-date:focus {
  outline: none;
  border-color: #FF6F61;
}

.person-edit-page .expand-icon {
  font-size: 10px;
  color: #94A3B8;
  transition: transform 0.2s;
}

.person-edit-page .expand-icon.expanded {
  transform: rotate(180deg);
}

.person-edit-page .remove-source-btn {
  width: 24px;
  height: 24px;
  border: none;
  border-radius: 50%;
  background: #FEE2E2;
  color: #EF4444;
  font-size: 14px;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.2s;
}

.person-edit-page .remove-source-btn:hover {
  background: #EF4444;
  color: white;
}

.person-edit-page .dates-hint {
  padding: 12px 14px;
  font-size: 12px;
  color: #94A3B8;
  font-style: italic;
}

/* ===================== SOURCE YEARS TABLE ===================== */

.person-edit-page .source-years-table {
  padding: 0;
}

.person-edit-page .source-years-table table {
  width: 100%;
  border-collapse: collapse;
}

.person-edit-page .source-years-table th {
  padding: 10px 12px;
  background: #F1F5F9;
  font-size: 11px;
  font-weight: 600;
  color: #64748B;
  text-align: left;
  border-bottom: 1px solid #E2E8F0;
}

.person-edit-page .source-years-table td {
  padding: 10px 12px;
  font-size: 13px;
  border-bottom: 1px solid #F1F5F9;
}

.person-edit-page .source-years-table tr:last-child td {
  border-bottom: none;
}

.person-edit-page .td-year {
  font-weight: 600;
  color: #334155;
  width: 60px;
}

.person-edit-page .td-brut {
  width: 140px;
}

.person-edit-page .input-wrapper {
  display: flex;
  align-items: center;
  border: 1px solid #E2E8F0;
  border-radius: 6px;
  overflow: hidden;
  background: white;
}

.person-edit-page .input-wrapper.needs-input {
  border-color: #FCD34D;
  background: #FFFBEB;
}

.person-edit-page .input-wrapper input {
  flex: 1 1;
  border: none;
  padding: 8px 10px;
  font-size: 13px;
  background: transparent;
  width: 80px;
}

.person-edit-page .input-wrapper input:focus {
  outline: none;
}

.person-edit-page .input-suffix {
  padding: 0 10px;
  font-size: 12px;
  color: #94A3B8;
  background: #F8FAFC;
}

.person-edit-page .td-detail {
  width: 40px;
  text-align: center;
}

.person-edit-page .detail-btn {
  width: 28px;
  height: 28px;
  border: 1px solid #E2E8F0;
  border-radius: 6px;
  background: white;
  cursor: pointer;
  font-size: 14px;
  transition: all 0.2s;
}

.person-edit-page .detail-btn:hover {
  border-color: #FF6F61;
  color: #FF6F61;
}

.person-edit-page .detail-btn.has-detail {
  background: #DCFCE7;
  border-color: #22C55E;
  color: #16A34A;
}

.person-edit-page .auto-value {
  color: #64748B;
  font-size: 13px;
}

/* ===================== DANSMAPOCHE SUMMARY ===================== */

.person-edit-page .dansmapoche-years {
  display: flex;
  gap: 16px;
  flex-wrap: wrap;
}

.person-edit-page .dansmapoche-year-card {
  flex: 1 1 280px;
  min-width: 240px;
  max-width: 400px;
  background: linear-gradient(135deg, #059669 0%, #10b981 100%);
  border-radius: 12px;
  padding: 16px;
  color: white;
}

.person-edit-page .year-label {
  font-size: 20px;
  font-weight: 700;
  margin-bottom: 12px;
}

.person-edit-page .year-breakdown {
  display: flex;
  flex-direction: column;
  gap: 6px;
}

.person-edit-page .breakdown-row {
  display: flex;
  justify-content: space-between;
  font-size: 13px;
}

.person-edit-page .row-label {
  opacity: 0.9;
}

.person-edit-page .row-value {
  font-weight: 500;
}

.person-edit-page .row-value.negative {
  color: #FCA5A5;
}

.person-edit-page .breakdown-row.dansmapoche-row {
  margin-top: 8px;
  padding-top: 8px;
  border-top: 1px solid rgba(255,255,255,0.2);
}

.person-edit-page .row-value.highlight {
  font-size: 18px;
  font-weight: 700;
}

.person-edit-page .monthly-equivalent {
  margin-top: 12px;
  font-size: 12px;
  opacity: 0.8;
  text-align: center;
}

.person-edit-page .no-data-message {
  text-align: center;
  padding: 30px;
  color: #94A3B8;
}

.person-edit-page .no-data-message p {
  margin: 0;
  font-size: 14px;
}

/* ===================== LINKED ENTITY INCOME ===================== */

.person-edit-page .linked-entity-banner {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 10px 16px;
  background: linear-gradient(135deg, #FFF3E0 0%, #FFE0B2 100%);
  border: 1px solid #FFB74D;
  border-radius: 6px;
  margin-bottom: 12px;
  font-size: 13px;
  color: #E65100;
}

.person-edit-page .linked-entity-banner .link-icon {
  font-size: 16px;
}

.person-edit-page .linked-entity-banner .readonly-badge {
  margin-left: auto;
  padding: 2px 8px;
  background: #FF9800;
  color: white;
  border-radius: 4px;
  font-size: 11px;
  font-weight: 600;
  text-transform: uppercase;
}

.person-edit-page .linked-entity-banner .editable-badge {
  margin-left: auto;
  padding: 3px 10px;
  background: #4CAF50;
  color: white;
  border-radius: 4px;
  font-size: 11px;
  font-weight: 600;
}

/* Dividend banner - golden theme */
.person-edit-page .linked-entity-banner.dividend-banner {
  background: linear-gradient(135deg, #FEF3C7 0%, #FDE68A 100%);
  color: #92400E;
  border-color: #F59E0B;
}

.person-edit-page .linked-entity-banner .info-badge {
  margin-left: auto;
  padding: 3px 10px;
  background: #F59E0B;
  color: white;
  border-radius: 4px;
  font-size: 11px;
  font-weight: 600;
}

.person-edit-page tr.from-entity {
  background: #FFFDE7;
}

.person-edit-page .readonly-value {
  padding: 8px 12px;
  background: #F5F5F5;
  border: 1px solid #E0E0E0;
  border-radius: 4px;
  color: #616161;
  font-weight: 500;
}

.person-edit-page .readonly-value.clickable {
  cursor: pointer;
  transition: all 0.2s ease;
}

.person-edit-page .readonly-value.clickable:hover {
  background: #EEEEEE;
  border-color: #BDBDBD;
}

/* Prorata info for linked incomes */
.person-edit-page .prorata-info {
  font-size: 11px;
  color: #9E9E9E;
  font-weight: 400;
}

.person-edit-page .prorata-info.clickable {
  color: #1976D2;
  cursor: pointer;
  pointer-events: auto;
  text-decoration: underline;
  text-decoration-style: dotted;
}

.person-edit-page .prorata-info.clickable:hover {
  color: #1565C0;
  text-decoration-style: solid;
}

/* Legacy prorata badge - kept for compatibility */
.person-edit-page .prorata-badge {
  margin-left: 6px;
  font-size: 11px;
  color: #FF9800;
  font-weight: 500;
  cursor: help;
  border-bottom: 1px dotted #FF9800;
}

/* Calculation info icon for entity-linked incomes */
.person-edit-page .calc-info-icon {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  margin-left: 6px;
  width: 18px;
  height: 18px;
  background: #2196F3;
  color: white;
  border-radius: 50%;
  font-size: 11px;
  font-weight: 600;
  cursor: help;
  transition: all 0.2s ease;
}

.person-edit-page .calc-info-icon:hover {
  background: #1976D2;
  transform: scale(1.1);
}

.person-edit-page .calc-info-icon.small {
  width: 16px;
  height: 16px;
  font-size: 10px;
  background: #9E9E9E;
}

.person-edit-page .calc-info-icon.small:hover {
  background: #757575;
}

.person-edit-page .readonly-value.with-detail {
  display: flex;
  align-items: center;
  gap: 4px;
}

/* Negative value styling */
.person-edit-page .auto-value.neg {
  color: #D32F2F;
}

/* ===================== CALCULATION POPOVER ===================== */

.calc-popover-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 2000;
  background: rgba(0, 0, 0, 0.3);
  display: flex;
  align-items: center;
  justify-content: center;
}

.calc-popover {
  background: white;
  border-radius: 12px;
  box-shadow: 0 10px 40px rgba(0, 0, 0, 0.25);
  width: 580px;
  max-width: 90vw;
  max-height: 85vh;
  overflow: hidden;
  display: flex;
  flex-direction: column;
}

.calc-popover-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 14px 18px;
  background: linear-gradient(135deg, #1565C0 0%, #1976D2 100%);
  color: white;
  font-weight: 600;
  font-size: 15px;
}

.calc-popover-header button {
  background: rgba(255, 255, 255, 0.2);
  border: none;
  color: white;
  width: 26px;
  height: 26px;
  border-radius: 50%;
  cursor: pointer;
  font-size: 18px;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: background 0.2s;
}

.calc-popover-header button:hover {
  background: rgba(255, 255, 255, 0.35);
}

.calc-popover-body {
  padding: 20px 24px;
  overflow-y: auto;
  flex: 1 1;
}

/* Explanation sections */
.calc-explanation {
  margin-bottom: 12px;
}

.explanation-title {
  font-weight: 600;
  font-size: 13px;
  color: #1976D2;
  margin-bottom: 4px;
}

.calc-explanation p {
  margin: 0;
  font-size: 13px;
  color: #475569;
  line-height: 1.5;
}

/* Exercice cards */
.calc-exercice {
  background: linear-gradient(135deg, #F8FAFC 0%, #F1F5F9 100%);
  border: 1px solid #E2E8F0;
  border-radius: 10px;
  padding: 14px;
  margin-bottom: 12px;
}

.exercice-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  font-weight: 600;
  font-size: 13px;
  color: #334155;
  margin-bottom: 10px;
  padding-bottom: 8px;
  border-bottom: 1px solid #CBD5E1;
}

.exercice-days {
  font-size: 11px;
  font-weight: 500;
  color: #64748B;
  background: #E2E8F0;
  padding: 2px 8px;
  border-radius: 4px;
}

.calc-detail-row {
  margin-bottom: 8px;
}

.detail-line {
  display: flex;
  justify-content: space-between;
  font-size: 12px;
  margin-bottom: 2px;
}

.detail-label {
  color: #64748B;
}

.detail-value {
  color: #334155;
  font-weight: 500;
}

.detail-line.formula {
  font-size: 11px;
  color: #059669;
  background: #ECFDF5;
  padding: 4px 8px;
  border-radius: 4px;
  margin-top: 4px;
}

.detail-line.formula span:first-child {
  color: #047857;
}

.detail-line.formula strong {
  color: #047857;
}

/* Total section */
.calc-total {
  margin-top: 16px;
  padding: 14px;
  background: linear-gradient(135deg, #1976D2 0%, #1565C0 100%);
  border-radius: 10px;
  color: white;
}

.total-header {
  font-weight: 600;
  font-size: 14px;
  margin-bottom: 10px;
  padding-bottom: 8px;
  border-bottom: 1px solid rgba(255, 255, 255, 0.3);
}

.total-row {
  display: flex;
  justify-content: space-between;
  font-size: 13px;
  margin-bottom: 6px;
}

.total-row.with-formula {
  flex-wrap: wrap;
  gap: 4px;
}

.total-label {
  min-width: 90px;
}

.total-formula {
  flex: 1 1;
  font-size: 12px;
  opacity: 0.85;
  font-family: 'Monaco', 'Menlo', monospace;
}

.total-row:last-child {
  margin-bottom: 0;
}

.total-value {
  font-weight: 700;
  font-size: 14px;
}

.calc-empty {
  color: #94A3B8;
  font-style: italic;
  text-align: center;
  padding: 30px;
  margin: 0;
}

/* ===================== FISCAL OPTION SECTION ===================== */

.fiscal-option-section {
  background: linear-gradient(135deg, #f0f9ff 0%, #e0f2fe 100%);
  border: 1px solid #0ea5e9;
}

.fiscal-option-section h4 {
  color: #0369a1;
}

.fiscal-option-row {
  display: flex;
  gap: 16px;
  flex-wrap: wrap;
}

.fiscal-option {
  flex: 1 1;
  min-width: 220px;
  display: flex;
  align-items: flex-start;
  gap: 10px;
  padding: 12px;
  border: 2px solid #bae6fd;
  border-radius: 8px;
  cursor: pointer;
  background: white;
  transition: all 0.15s ease;
}

.fiscal-option:hover {
  border-color: #7dd3fc;
  background: #f0f9ff;
}

.fiscal-option.selected {
  border-color: #0284c7;
  background: #e0f2fe;
}

.fiscal-option input[type="radio"] {
  margin-top: 2px;
  accent-color: #0284c7;
}

.fiscal-option-content {
  display: flex;
  flex-direction: column;
  gap: 2px;
}

.fiscal-option-label {
  font-weight: 600;
  color: #0c4a6e;
  font-size: 13px;
}

.fiscal-option-desc {
  font-size: 11px;
  color: #0369a1;
  line-height: 1.3;
}

.fiscal-option-info {
  margin-top: 12px;
  margin-bottom: 0;
  padding: 8px 12px;
  background: white;
  border-radius: 6px;
  font-size: 12px;
  color: #0369a1;
  border: 1px solid #bae6fd;
}

/* ===================== DISPENSE ACOMPTE SECTION ===================== */

.dispense-section {
  margin-top: 16px;
  padding: 14px;
  background: linear-gradient(135deg, #fefce8 0%, #fef3c7 100%);
  border: 1px solid #f59e0b;
  border-radius: 8px;
}

.dispense-header {
  display: flex;
  align-items: center;
  gap: 8px;
  margin-bottom: 12px;
}

.dispense-icon {
  font-size: 16px;
}

.dispense-title {
  font-size: 14px;
  font-weight: 600;
  color: #92400e;
}

.dispense-eligibility {
  background: white;
  border-radius: 6px;
  padding: 10px 12px;
  margin-bottom: 12px;
}

.eligibility-row {
  display: flex;
  justify-content: space-between;
  font-size: 12px;
  color: #78350f;
  margin-bottom: 4px;
}

.eligibility-value {
  font-weight: 600;
}

.eligibility-status {
  margin-top: 8px;
  padding: 6px 10px;
  border-radius: 4px;
  font-size: 12px;
  font-weight: 600;
}

.eligibility-status.eligible {
  background: #ecfdf5;
  color: #059669;
  border: 1px solid #a7f3d0;
}

.eligibility-status.not-eligible {
  background: #fef2f2;
  color: #dc2626;
  border: 1px solid #fecaca;
}

.eligibility-deadline {
  margin-top: 8px;
  font-size: 12px;
  color: #92400e;
}

.eligibility-deadline strong {
  color: #dc2626;
}

.dispense-companies {
  background: white;
  border-radius: 6px;
  padding: 10px 12px;
  margin-bottom: 12px;
}

.dispense-companies-label {
  font-size: 12px;
  font-weight: 600;
  color: #78350f;
  margin-bottom: 8px;
}

.dispense-company-option {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 6px 8px;
  border-radius: 4px;
  cursor: pointer;
  margin-bottom: 4px;
}

.dispense-company-option:hover {
  background: #fef3c7;
}

.dispense-company-option input[type="checkbox"] {
  width: 16px;
  height: 16px;
  accent-color: #f59e0b;
}

.dispense-company-name {
  font-size: 13px;
  color: #1f2937;
}

.dispense-dividend-year {
  font-size: 11px;
  color: #6b7280;
  margin-left: 4px;
}

.dispense-info {
  margin: 0;
  padding: 8px 10px;
  background: white;
  border-radius: 4px;
  font-size: 11px;
  color: #92400e;
  border: 1px solid #fcd34d;
}

/* ===================== CAPITAL INCOME (DIVIDENDS) SECTION ===================== */

.capital-income-section {
  background: linear-gradient(135deg, #fefce8 0%, #fef3c7 100%);
  border: 1px solid #f59e0b;
}

.capital-income-section h4 {
  color: #92400e;
  margin-bottom: 16px;
}

/* Source header */
.capital-source-header {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 10px 14px;
  background: white;
  border-radius: 8px;
  margin-bottom: 12px;
  border: 1px solid #fcd34d;
}

.capital-source-icon {
  font-size: 16px;
}

.capital-source-name {
  font-size: 13px;
  color: #78350f;
}

.capital-source-name strong {
  color: #92400e;
}

.capital-source-percent {
  font-size: 12px;
  color: #a16207;
  margin-left: auto;
}

/* Capital income table */
.capital-income-table {
  background: white;
  border-radius: 8px;
  overflow: hidden;
  border: 1px solid #fcd34d;
}

.capital-income-table table {
  width: 100%;
  border-collapse: collapse;
}

.capital-income-table th {
  padding: 12px 14px;
  background: linear-gradient(135deg, #fef3c7 0%, #fde68a 100%);
  font-size: 11px;
  font-weight: 600;
  color: #92400e;
  text-align: left;
  border-bottom: 1px solid #fcd34d;
}

.capital-income-table td {
  padding: 12px 14px;
  font-size: 13px;
  border-bottom: 1px solid #fef3c7;
  vertical-align: middle;
}

.capital-income-table tr:last-child td {
  border-bottom: none;
}

.capital-income-table .td-year {
  font-weight: 600;
  color: #78350f;
  width: 80px;
}

.capital-income-table .td-acompte {
  min-width: 160px;
}

.capital-income-table .td-detail {
  width: 40px;
  text-align: center;
}

.capital-value {
  font-weight: 500;
  color: #334155;
}

.capital-value.neg {
  color: #dc2626;
}

.capital-value.pos {
  color: #059669;
}

.capital-value.neutral {
  color: #9ca3af;
}

.capital-value.highlight {
  color: #059669;
  font-weight: 700;
  font-size: 14px;
}

.acompte-detail {
  display: block;
  font-size: 10px;
  color: #9ca3af;
  margin-top: 2px;
}

/* Tax reminder at bottom */
.capital-tax-reminder {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 12px 14px;
  background: white;
  border-radius: 8px;
  margin-top: 12px;
  border: 1px solid #fcd34d;
}

.tax-badge {
  display: flex;
  align-items: center;
  gap: 6px;
  padding: 6px 12px;
  background: linear-gradient(135deg, #f59e0b 0%, #d97706 100%);
  color: white;
  border-radius: 6px;
  font-size: 12px;
  font-weight: 600;
}

.tax-hint {
  font-size: 12px;
  color: #78350f;
}

/* ===================== DIVIDEND POPOVER STYLES ===================== */

.dividend-popover {
  width: 600px;
}

.dividend-header {
  background: linear-gradient(135deg, #f59e0b 0%, #d97706 100%);
}

.dividend-tax-badge-large {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 14px 16px;
  background: linear-gradient(135deg, #fef3c7 0%, #fde68a 100%);
  border: 1px solid #fcd34d;
  border-radius: 8px;
  margin-bottom: 20px;
}

.dividend-tax-badge-large .badge-icon {
  font-size: 24px;
}

.dividend-tax-badge-large .badge-text {
  font-size: 15px;
  font-weight: 600;
  color: #92400e;
}

/* Timeline styles */
.dividend-timeline {
  margin-bottom: 20px;
}

.timeline-title {
  font-size: 14px;
  font-weight: 600;
  color: #334155;
  margin-bottom: 14px;
  padding-bottom: 8px;
  border-bottom: 1px solid #e2e8f0;
}

.timeline-step {
  display: flex;
  gap: 14px;
  padding: 14px 0;
  border-bottom: 1px solid #f1f5f9;
}

.timeline-step:last-child {
  border-bottom: none;
}

.step-marker {
  width: 36px;
  height: 36px;
  background: linear-gradient(135deg, #f59e0b 0%, #d97706 100%);
  color: white;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 12px;
  font-weight: 700;
  flex-shrink: 0;
}

.step-content {
  flex: 1 1;
}

.step-title {
  font-size: 13px;
  font-weight: 600;
  color: #1e293b;
  margin-bottom: 8px;
}

.step-detail {
  display: flex;
  justify-content: space-between;
  font-size: 12px;
  color: #475569;
  margin-bottom: 4px;
  padding: 4px 8px;
  border-radius: 4px;
}

.step-detail.highlight-neg {
  background: #fef2f2;
  color: #dc2626;
}

.step-detail.highlight-pos {
  background: #ecfdf5;
  color: #059669;
}

.step-detail.neutral {
  background: #f8fafc;
  color: #64748b;
}

.step-detail.info {
  background: #f0f9ff;
  color: #0369a1;
  font-style: italic;
}

.step-value {
  font-weight: 600;
}

.step-breakdown {
  display: flex;
  gap: 16px;
  font-size: 11px;
  color: #64748b;
  padding: 4px 8px;
  margin-bottom: 4px;
}

.step-result {
  display: flex;
  justify-content: space-between;
  font-size: 12px;
  color: #059669;
  font-weight: 600;
  padding: 6px 10px;
  background: #ecfdf5;
  border-radius: 4px;
  margin-top: 6px;
}

.step-formula {
  font-size: 11px;
  color: #64748b;
  padding: 4px 8px;
  background: #f8fafc;
  border-radius: 4px;
  font-family: 'Monaco', 'Menlo', monospace;
  margin-top: 4px;
}

/* Summary section */
.dividend-summary {
  background: linear-gradient(135deg, #f59e0b 0%, #d97706 100%);
  border-radius: 10px;
  padding: 16px;
  color: white;
}

.summary-title {
  font-size: 14px;
  font-weight: 600;
  margin-bottom: 12px;
  padding-bottom: 8px;
  border-bottom: 1px solid rgba(255, 255, 255, 0.3);
}

.summary-row {
  display: flex;
  justify-content: space-between;
  font-size: 13px;
  margin-bottom: 6px;
}

.summary-row.neg {
  opacity: 0.9;
}

.summary-row.total {
  margin-top: 8px;
  padding-top: 8px;
  border-top: 1px solid rgba(255, 255, 255, 0.3);
  font-size: 15px;
  font-weight: 700;
}

.summary-rate {
  margin-top: 10px;
  font-size: 11px;
  opacity: 0.85;
  text-align: center;
  padding: 6px 10px;
  background: rgba(255, 255, 255, 0.15);
  border-radius: 4px;
}

/* ===================== CAPITAL INCOME OPTIONS SECTION ===================== */

.person-edit-page .capital-income-options {
  background: #f8fafc;
  border: 1px solid #e2e8f0;
  border-radius: 10px;
  padding: 16px 20px;
  margin-bottom: 20px;
}

.person-edit-page .capital-income-options .options-header {
  display: flex;
  align-items: center;
  gap: 8px;
  margin-bottom: 14px;
}

.person-edit-page .capital-income-options .options-icon {
  font-size: 18px;
}

.person-edit-page .capital-income-options .options-title {
  font-size: 14px;
  font-weight: 600;
  color: #1e293b;
}

/* Two-column grid for tax options */
.person-edit-page .capital-income-options .tax-options-grid {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 12px;
  margin-bottom: 14px;
}

.person-edit-page .capital-income-options .tax-option-card {
  display: flex;
  align-items: flex-start;
  gap: 10px;
  padding: 12px 14px;
  background: white;
  border: 2px solid #e2e8f0;
  border-radius: 8px;
  cursor: pointer;
  transition: all 0.15s ease;
}

.person-edit-page .capital-income-options .tax-option-card:hover {
  border-color: #f59e0b;
  background: #fffbeb;
}

.person-edit-page .capital-income-options .tax-option-card.selected {
  border-color: #f59e0b;
  background: linear-gradient(135deg, #fffbeb 0%, #fef3c7 100%);
  box-shadow: 0 2px 8px rgba(245, 158, 11, 0.15);
}

.person-edit-page .capital-income-options .tax-option-card input[type="radio"] {
  display: none;
}

.person-edit-page .capital-income-options .option-content {
  flex: 1 1;
}

.person-edit-page .capital-income-options .option-title {
  font-size: 13px;
  font-weight: 600;
  color: #1e293b;
  margin-bottom: 4px;
}

.person-edit-page .capital-income-options .option-bullet {
  color: #94a3b8;
  margin-right: 4px;
}

.person-edit-page .capital-income-options .tax-option-card.selected .option-bullet {
  color: #f59e0b;
}

.person-edit-page .capital-income-options .option-default {
  font-weight: 400;
  color: #64748b;
  font-size: 11px;
}

.person-edit-page .capital-income-options .option-case {
  font-weight: 400;
  color: #64748b;
  font-size: 11px;
}

.person-edit-page .capital-income-options .option-description {
  font-size: 11px;
  color: #64748b;
  line-height: 1.5;
  padding-left: 16px;
}

.person-edit-page .capital-income-options .option-detail {
  color: #059669;
  font-style: italic;
}

/* Info note at bottom */
.person-edit-page .capital-income-options .tax-info-note {
  display: flex;
  align-items: flex-start;
  gap: 8px;
  padding: 10px 12px;
  background: #e0f2fe;
  border-radius: 6px;
  border: 1px solid #bae6fd;
}

.person-edit-page .capital-income-options .tax-info-note .info-icon {
  font-size: 14px;
  flex-shrink: 0;
}

.person-edit-page .capital-income-options .tax-info-note .info-text {
  font-size: 11px;
  color: #0369a1;
  line-height: 1.5;
}

.person-edit-page .capital-income-options .tax-info-note strong {
  font-weight: 600;
}

/* ===================== DIVIDEND TABLE COLUMNS ===================== */

/* Column header indicators - show what's editable vs read-only */
.person-edit-page .source-years-table th {
  position: relative;
}

.person-edit-page .source-years-table th .col-label {
  display: inline;
}

.person-edit-page .source-years-table th .col-lock-icon,
.person-edit-page .source-years-table th .col-edit-icon,
.person-edit-page .source-years-table th .col-help-icon {
  margin-left: 4px;
  font-size: 10px;
  cursor: help;
  opacity: 0.7;
  vertical-align: middle;
}

.person-edit-page .source-years-table th .col-lock-icon {
  color: #94a3b8;
}

.person-edit-page .source-years-table th .col-edit-icon {
  color: #3b82f6;
}

.person-edit-page .source-years-table th .col-help-icon {
  color: #f59e0b;
  font-weight: bold;
}

.person-edit-page .source-years-table th:hover .col-lock-icon,
.person-edit-page .source-years-table th:hover .col-edit-icon,
.person-edit-page .source-years-table th:hover .col-help-icon {
  opacity: 1;
}

/* Column header background colors for clarity */
.person-edit-page .source-years-table th.editable-col {
  background: linear-gradient(135deg, #eff6ff 0%, #dbeafe 100%);
}

.person-edit-page .source-years-table th.readonly-col {
  background: linear-gradient(135deg, #f8fafc 0%, #f1f5f9 100%);
}

/* Clickable column headers */
.person-edit-page .source-years-table th.clickable-header {
  cursor: pointer;
  transition: background 0.2s;
}

.person-edit-page .source-years-table th.clickable-header:hover {
  background: linear-gradient(135deg, #fef3c7 0%, #fde68a 100%) !important;
}

.person-edit-page .source-years-table th.clickable-header:hover .col-help-icon {
  transform: scale(1.2);
  opacity: 1;
}

/* ===================== HELP MODALS ===================== */

.help-modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 2000;
  animation: fadeIn 0.2s ease;
}

@keyframes fadeIn {
  from { opacity: 0; }
  to { opacity: 1; }
}

.help-modal {
  background: white;
  border-radius: 12px;
  width: 90%;
  max-width: 600px;
  max-height: 80vh;
  overflow: hidden;
  box-shadow: 0 20px 60px rgba(0, 0, 0, 0.3);
  animation: slideUp 0.3s ease;
}

@keyframes slideUp {
  from { transform: translateY(20px); opacity: 0; }
  to { transform: translateY(0); opacity: 1; }
}

.help-modal-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 16px 20px;
  background: linear-gradient(135deg, #3b82f6 0%, #1d4ed8 100%);
  color: white;
  font-weight: 600;
  font-size: 16px;
}

.help-modal-header button {
  background: rgba(255, 255, 255, 0.2);
  border: none;
  color: white;
  width: 28px;
  height: 28px;
  border-radius: 50%;
  cursor: pointer;
  font-size: 18px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.help-modal-header button:hover {
  background: rgba(255, 255, 255, 0.3);
}

.help-modal-body {
  padding: 20px;
  overflow-y: auto;
  max-height: calc(80vh - 60px);
}

.help-section {
  margin-bottom: 20px;
  padding-bottom: 16px;
  border-bottom: 1px solid #e2e8f0;
}

.help-section:last-child {
  border-bottom: none;
  margin-bottom: 0;
}

.help-section h4 {
  margin: 0 0 10px 0;
  font-size: 14px;
  font-weight: 600;
  color: #1e293b;
}

.help-section p {
  margin: 0 0 8px 0;
  font-size: 13px;
  line-height: 1.6;
  color: #475569;
}

.help-section ul {
  margin: 8px 0;
  padding-left: 20px;
}

.help-section ul li {
  font-size: 13px;
  line-height: 1.6;
  color: #475569;
  margin-bottom: 4px;
}

.help-section .help-note {
  background: #f1f5f9;
  border-left: 3px solid #94a3b8;
  padding: 8px 12px;
  font-size: 12px;
  color: #64748b;
  margin-top: 8px;
  border-radius: 0 4px 4px 0;
}

/* PFU highlight */
.help-section.highlight-pfu {
  background: linear-gradient(135deg, #eff6ff 0%, #dbeafe 100%);
  border: 1px solid #93c5fd;
  border-radius: 8px;
  padding: 12px 16px;
  margin: 12px 0;
}

.help-section.highlight-pfu h4 {
  color: #1d4ed8;
}

/* Barème highlight */
.help-section.highlight-bareme {
  background: linear-gradient(135deg, #fff7ed 0%, #ffedd5 100%);
  border: 1px solid #fdba74;
  border-radius: 8px;
  padding: 12px 16px;
  margin: 12px 0;
}

.help-section.highlight-bareme h4 {
  color: #c2410c;
}

/* Warning highlight */
.help-section.highlight-warning {
  background: linear-gradient(135deg, #fefce8 0%, #fef9c3 100%);
  border: 1px solid #fbbf24;
  border-radius: 8px;
  padding: 12px 16px;
  margin: 12px 0;
}

.help-section.highlight-warning h4 {
  color: #b45309;
}

.help-note.warning {
  background: #fef3c7;
  border-left: 3px solid #f59e0b;
  padding: 8px 12px;
  margin-top: 10px;
  border-radius: 0 4px 4px 0;
}

/* Comparison table in help modal */
.help-comparison-table {
  width: 100%;
  border-collapse: collapse;
  margin-top: 10px;
  font-size: 12px;
}

.help-comparison-table th,
.help-comparison-table td {
  padding: 8px 12px;
  text-align: left;
  border: 1px solid #e2e8f0;
}

.help-comparison-table th {
  background: #f8fafc;
  font-weight: 600;
  color: #475569;
}

.help-comparison-table tr:nth-child(even) td {
  background: #f8fafc;
}

.help-comparison-table td:last-child {
  font-weight: 500;
  color: #059669;
}

/* Date column */
.person-edit-page .source-years-table .td-date {
  width: 100px;
}

.person-edit-page .source-years-table .date-value {
  font-size: 11px;
  color: #64748b;
}

.person-edit-page .source-years-table .date-input {
  width: 100px;
  padding: 4px 6px;
  border: 1px solid #e2e8f0;
  border-radius: 4px;
  font-size: 11px;
}

/* Dispense column */
.person-edit-page .source-years-table .td-dispense {
  width: 60px;
  text-align: center;
}

.person-edit-page .dispense-checkbox {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
}

.person-edit-page .dispense-checkbox input[type="checkbox"] {
  display: none;
}

.person-edit-page .dispense-checkbox .checkbox-label {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 24px;
  height: 24px;
  border-radius: 50%;
  font-size: 12px;
  font-weight: 600;
  border: 2px solid #e2e8f0;
  background: white;
  transition: all 0.15s ease;
}

.person-edit-page .dispense-checkbox:hover .checkbox-label {
  border-color: #f59e0b;
}

.person-edit-page .dispense-checkbox input:checked + .checkbox-label {
  background: #059669;
  border-color: #059669;
  color: white;
}

.person-edit-page .dispense-checkbox.disabled {
  cursor: not-allowed;
  opacity: 0.5;
}

.person-edit-page .dispense-checkbox.disabled .checkbox-label {
  background: #fee2e2;
  border-color: #fecaca;
  color: #dc2626;
}

/* Régime column */
.person-edit-page .source-years-table .th-regime,
.person-edit-page .source-years-table .th-dispense {
  font-size: 11px;
  cursor: help;
}

.person-edit-page .source-years-table .td-regime {
  min-width: 70px;
}

.person-edit-page .source-years-table .regime-select {
  padding: 4px 6px;
  border: 1px solid #d1d5db;
  border-radius: 4px;
  font-size: 11px;
  background: white;
  cursor: pointer;
  width: 65px;
}

.person-edit-page .source-years-table .regime-select:focus {
  outline: none;
  border-color: #3b82f6;
  box-shadow: 0 0 0 2px rgba(59, 130, 246, 0.2);
}

/* Dispense column */
.person-edit-page .source-years-table .td-dispense {
  min-width: 100px;
}

.person-edit-page .dispense-control {
  display: flex;
  align-items: center;
  gap: 4px;
}

.person-edit-page .dispense-control input[type="checkbox"] {
  width: 14px;
  height: 14px;
  cursor: pointer;
}

.person-edit-page .dispense-date {
  padding: 2px 4px;
  border: 1px solid #d1d5db;
  border-radius: 3px;
  font-size: 10px;
  width: 85px;
}

.person-edit-page .dispense-date:focus {
  outline: none;
  border-color: #3b82f6;
}

.person-edit-page .dispense-badge {
  display: inline-block;
  margin-left: 4px;
  color: #10b981;
  font-weight: 600;
  font-size: 12px;
}

/* Acompte column */
.person-edit-page .source-years-table .th-acompte,
.person-edit-page .source-years-table .th-regul {
  cursor: help;
  position: relative;
}

.person-edit-page .source-years-table .th-acompte:hover::after,
.person-edit-page .source-years-table .th-regul:hover::after {
  content: attr(title);
  position: absolute;
  top: 100%;
  left: 50%;
  transform: translateX(-50%);
  background: #1e293b;
  color: white;
  padding: 8px 12px;
  border-radius: 6px;
  font-size: 11px;
  font-weight: 400;
  white-space: normal;
  width: 220px;
  z-index: 100;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.2);
}

.person-edit-page .source-years-table .td-acompte .auto-value.neg {
  color: #dc2626;
}

.person-edit-page .source-years-table .td-acompte .auto-value.reduced {
  color: #f59e0b;
}

/* Régul IR column */
.person-edit-page .source-years-table .td-regul {
  text-align: right;
  min-width: 100px;
}

.person-edit-page .source-years-table .td-regul .auto-value {
  font-size: 12px;
}

.person-edit-page .source-years-table .td-regul .auto-value.neg {
  color: #dc2626;
}

.person-edit-page .source-years-table .td-regul .auto-value.pos {
  color: #059669;
}

/* Net column highlight */
.person-edit-page .source-years-table .td-net .auto-value.highlight,
.person-edit-page .source-years-table .highlight {
  color: #059669;
  font-weight: 700;
}

/* Imposable value (Barème mode) */
.person-edit-page .source-years-table .td-net .auto-value.imposable-value {
  color: #f59e0b;
  font-weight: 600;
  display: inline-flex;
  align-items: center;
  gap: 4px;
}

.person-edit-page .source-years-table .imposable-badge {
  display: inline-block;
  font-size: 8px;
  font-weight: 700;
  padding: 1px 4px;
  background: #fef3c7;
  color: #b45309;
  border-radius: 3px;
  border: 1px solid #f59e0b;
  vertical-align: middle;
}

/* Imposable badge in help modal */
.imposable-badge-inline {
  display: inline-block;
  font-size: 10px;
  font-weight: 700;
  padding: 2px 5px;
  background: #fef3c7;
  color: #b45309;
  border-radius: 3px;
  border: 1px solid #f59e0b;
  vertical-align: middle;
  margin-left: 4px;
}

/* DansMaPoche year card - clickable */
.dansmapoche-year-card.clickable {
  cursor: pointer;
  transition: all 0.2s ease;
}

.dansmapoche-year-card.clickable:hover {
  transform: translateY(-2px);
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
}

.dansmapoche-year-card .view-detail-icon {
  font-size: 12px;
  margin-left: 6px;
  opacity: 0.5;
}

.dansmapoche-year-card:hover .view-detail-icon {
  opacity: 1;
}

/* Tax badge in DansMaPoche cards */
.dansmapoche-year-card .tax-badge {
  display: inline-block;
  font-size: 9px;
  font-weight: 700;
  padding: 1px 5px;
  border-radius: 3px;
  margin-left: 6px;
  vertical-align: middle;
}

.dansmapoche-year-card .tax-badge.pfu {
  background: #dbeafe;
  color: #1d4ed8;
  border: 1px solid #93c5fd;
}

.dansmapoche-year-card .tax-badge.bareme {
  background: #ffedd5;
  color: #c2410c;
  border: 1px solid #fdba74;
}

/* Dividend row in breakdown */
.dansmapoche-year-card .breakdown-row.dividend-row {
  border-top: 1px dashed #e2e8f0;
  margin-top: 4px;
  padding-top: 4px;
}

/* DansMaPoche Breakdown Modal */
.dmp-breakdown-modal {
  width: 700px;
  max-width: 95vw;
  max-height: 85vh;
  overflow-y: auto;
}

.dmp-header {
  background: linear-gradient(135deg, #059669 0%, #10b981 100%);
  color: white;
}

.dmp-section {
  padding: 12px;
  border-bottom: 1px solid #e2e8f0;
}

.dmp-section:last-child {
  border-bottom: none;
}

.dmp-section-title {
  font-weight: 600;
  font-size: 13px;
  color: #1e293b;
  margin-bottom: 10px;
  display: flex;
  align-items: center;
  gap: 8px;
}

.dmp-detail-row {
  display: flex;
  justify-content: space-between;
  font-size: 12px;
  padding: 4px 0;
  color: #64748b;
}

.dmp-detail-row span:last-child {
  font-weight: 500;
  color: #1e293b;
}

/* Income item in breakdown */
.dmp-income-item {
  background: #f8fafc;
  border-radius: 6px;
  padding: 8px 10px;
  margin-bottom: 8px;
}

.dmp-income-item.dividend {
  background: #fffbeb;
  border: 1px solid #fef3c7;
}

.dmp-income-item .income-label {
  font-weight: 500;
  font-size: 12px;
  color: #1e293b;
  margin-bottom: 4px;
}

.dmp-income-item .linked-tag {
  font-size: 10px;
  color: #64748b;
  margin-left: 8px;
}

.dmp-income-item .income-values {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  font-size: 11px;
  color: #64748b;
}

.dmp-income-item .income-values span {
  background: white;
  padding: 2px 6px;
  border-radius: 3px;
  border: 1px solid #e2e8f0;
}

/* Calculation rows */
.dmp-calc-row {
  display: flex;
  justify-content: space-between;
  padding: 6px 0;
  font-size: 12px;
  border-bottom: 1px dotted #e2e8f0;
}

.dmp-calc-row:last-of-type {
  border-bottom: none;
}

.dmp-calc-row span:first-child {
  color: #64748b;
}

.dmp-calc-row span:last-child {
  font-weight: 500;
  color: #1e293b;
}

.dmp-calc-row span.positive {
  color: #059669;
}

.dmp-calc-row.highlight-neg span:last-child {
  color: #dc2626;
}

.dmp-calc-row.result {
  background: #f1f5f9;
  margin: 8px -10px 0;
  padding: 8px 10px;
  border-radius: 4px;
  font-weight: 600;
}

.dmp-calc-row.final {
  background: linear-gradient(135deg, #ecfdf5 0%, #d1fae5 100%);
  margin: 8px -10px 0;
  padding: 10px 10px;
  border-radius: 4px;
  font-weight: 700;
  font-size: 14px;
}

.dmp-calc-row.final span.highlight {
  color: #059669;
  font-size: 16px;
}

.dmp-formula {
  font-size: 11px;
  color: #64748b;
  font-style: italic;
  text-align: right;
  padding: 4px 0;
  border-top: 1px dotted #e2e8f0;
  margin-top: 4px;
}

/* Tax badge large */
.tax-badge-large {
  font-size: 10px;
  font-weight: 600;
  padding: 3px 8px;
  border-radius: 4px;
  margin-left: auto;
}

.tax-badge-large.pfu {
  background: #dbeafe;
  color: #1d4ed8;
  border: 1px solid #93c5fd;
}

.tax-badge-large.bareme {
  background: #ffedd5;
  color: #c2410c;
  border: 1px solid #fdba74;
}

/* Summary section */
.dmp-summary {
  background: #f0fdf4;
}

.dmp-monthly {
  text-align: center;
  font-size: 13px;
  color: #059669;
  font-weight: 500;
  margin-top: 8px;
  padding-top: 8px;
  border-top: 1px dashed #a7f3d0;
}
`, "",{"version":3,"sources":["webpack://./src/components/Person/PersonEditPage.css"],"names":[],"mappings":"AAAA,6CAA6C;AAC7C,yDAAyD;;AAEzD,iEAAiE;AACjE,kFAAkF;;AAElF;EACE,eAAe;EACf,UAAU,GAAG,kDAAkD;EAC/D,WAAW,GAAG,6CAA6C;EAC3D,WAAW,GAAG,iBAAiB;EAC/B,YAAY,GAAG,iBAAiB;EAChC,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,aAAa,GAAG,8CAA8C;EAC9D,gBAAgB;EAChB,mBAAmB,GAAG,8BAA8B;EACpD,yBAAyB,GAAG,uBAAuB;EACnD,0CAA0C;AAC5C;;AAEA;EACE;IACE,SAAS;IACT,UAAU;IACV,UAAU;IACV,WAAW;EACb;AACF;;AAEA,gCAAgC;AAChC;EACE,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,gBAAgB;EAChB,YAAY;AACd;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,YAAY;EACZ,eAAe;EACf,cAAc;AAChB;;AAEA,uDAAuD;;AAEvD;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,kBAAkB;EAClB,6DAA6D;EAC7D,YAAY;EACZ,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,iCAAiC;EACjC,iBAAiB;EACjB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,iBAAiB;EACjB,iCAAiC;EACjC,uCAAuC;EACvC,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA;EACE,kCAAkC;EAClC,2BAA2B;AAC7B;;AAEA;EACE,YAAY;EACZ,YAAY;AACd;;AAEA,0CAA0C;AAC1C;EACE,kCAAkC;EAClC,8CAA8C;AAChD;;AAEA;EACE,WAAW,YAAY,EAAE;EACzB,MAAM,UAAU,EAAE;AACpB;;AAEA,sCAAsC;AACtC;EACE,mCAAmC;EACnC,qCAAqC;EACrC,qCAAqC;AACvC;;AAEA;EACE,KAAK,mBAAmB,EAAE,2CAA2C,EAAE;EACvE,MAAM,sBAAsB,EAAE,gDAAgD,EAAE;EAChF,OAAO,mBAAmB,EAAE,yCAAyC,EAAE;AACzE;;AAEA;EACE,oCAAoC;EACpC,YAAY;EACZ,eAAe;EACf,eAAe;EACf,YAAY;EACZ,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,2BAA2B;AAC7B;;AAEA;EACE,oCAAoC;AACtC;;AAEA,kEAAkE;AAClE,sCAAsC;;AAEtC;EACE,aAAa;EACb,8BAA8B;EAC9B,SAAS;AACX;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,cAAc;EACd,gBAAgB;AAClB;;AAEA,0BAA0B;AAC1B;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,eAAe;AACjB;;AAEA,2BAA2B;AAC3B;EACE,aAAa;EACb,QAAQ;AACV;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,yBAAyB;EACzB,kBAAkB;EAClB,iBAAiB;EACjB,eAAe;EACf,qBAAqB;EACrB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,UAAU;AACZ;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,qBAAqB;EACrB,mBAAmB;AACrB;;AAEA;EACE,qBAAqB;EACrB,mBAAmB;AACrB;;AAEA,4BAA4B;AAC5B;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,yBAAyB;EACzB,kBAAkB;EAClB,iBAAiB;EACjB,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,eAAe;EACf,qBAAqB;AACvB;;AAEA;EACE,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,kBAAkB;AACpB;;AAEA,2BAA2B;AAC3B;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,eAAe;EACf,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,qBAAqB;AACvB;;AAEA,iBAAiB;AACjB;EACE,aAAa;EACb,qBAAqB;EACrB,QAAQ;EACR,iBAAiB;EACjB,6DAA6D;EAC7D,mBAAmB;EACnB,YAAY;EACZ,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,YAAY;AACd;;AAEA,qDAAqD;;AAErD;EACE,SAAO;EACP,gBAAgB;EAChB,kBAAkB;EAClB,aAAa;EACb,0BAA0B;EAC1B,SAAS;EACT,oBAAoB;AACtB;;AAEA,8DAA8D;;AAE9D;EACE,iBAAiB;EACjB,mBAAmB;EACnB,aAAa;EACb,yCAAyC;AAC3C;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,mBAAmB;EACnB,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,gBAAgB;AAClB;;AAEA,qDAAqD;AACrD;;EAEE,wCAAwC;AAC1C;;AAEA,8DAA8D;;AAE9D;EACE,aAAa;EACb,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,SAAO;AACT;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,kBAAkB;AACpB;;AAEA;;EAEE,WAAW;EACX,kBAAkB;EAClB,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;EACf,6BAA6B;EAC7B,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,qBAAqB;AACvB;;AAEA,6DAA6D;;AAE7D;EACE,aAAa;EACb,QAAQ;EACR,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,QAAQ;EACR,kBAAkB;EAClB,yBAAyB;EACzB,mBAAmB;EACnB,eAAe;EACf,oBAAoB;EACpB,eAAe;AACjB;;AAEA;EACE,qBAAqB;EACrB,mBAAmB;AACrB;;AAEA;EACE,qBAAqB;EACrB,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,gBAAgB;AAClB;;AAEA,iEAAiE;;AAEjE;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,yBAAyB;EACzB,kBAAkB;EAClB,iBAAiB;EACjB,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,eAAe;EACf,oBAAoB;AACtB;;AAEA;EACE,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,kBAAkB;AACpB;;AAEA,yDAAyD;;AAEzD;EACE,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,qBAAqB;AACvB;;AAEA,qEAAqE;;AAErE;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,kBAAkB;EAClB,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA,mEAAmE;;AAEnE;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,QAAQ;EACR,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;EACjB,yBAAyB;EACzB,mBAAmB;EACnB,iBAAiB;EACjB,eAAe;EACf,oBAAoB;EACpB,eAAe;AACjB;;AAEA;EACE,qBAAqB;EACrB,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA,oEAAoE;;AAEpE;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,SAAS;EACT,eAAe;AACjB;;AAEA,mEAAmE;;AAEnE;EACE,yBAAyB;EACzB,mBAAmB;EACnB,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,qBAAqB;EACrB,yCAAyC;AAC3C;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,kBAAkB;EAClB,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,SAAO;EACP,gBAAgB;EAChB,iBAAiB;EACjB,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,qBAAqB;AACvB;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;EACf,iBAAiB;EACjB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,qBAAqB;AACvB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,0BAA0B;AAC5B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,mBAAmB;EACnB,cAAc;EACd,eAAe;EACf,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,oBAAoB;AACtB;;AAEA;EACE,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,cAAc;EACd,kBAAkB;AACpB;;AAEA,mEAAmE;;AAEnE;EACE,UAAU;AACZ;;AAEA;EACE,WAAW;EACX,yBAAyB;AAC3B;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,gBAAgB;EAChB,gCAAgC;AAClC;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,gCAAgC;AAClC;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,WAAW;AACb;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,qBAAqB;EACrB,mBAAmB;AACrB;;AAEA;EACE,SAAO;EACP,YAAY;EACZ,iBAAiB;EACjB,eAAe;EACf,uBAAuB;EACvB,WAAW;AACb;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,eAAe;EACf,eAAe;EACf,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,yBAAyB;EACzB,kBAAkB;EAClB,iBAAiB;EACjB,eAAe;EACf,eAAe;EACf,oBAAoB;AACtB;;AAEA;EACE,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,eAAe;AACjB;;AAEA,oEAAoE;;AAEpE;EACE,aAAa;EACb,SAAS;EACT,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,6DAA6D;EAC7D,mBAAmB;EACnB,aAAa;EACb,YAAY;AACd;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,eAAe;AACjB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,2CAA2C;AAC7C;;AAEA;EACE,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,cAAc;AAChB;;AAEA;EACE,SAAS;EACT,eAAe;AACjB;;AAEA,qEAAqE;;AAErE;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,kBAAkB;EAClB,6DAA6D;EAC7D,yBAAyB;EACzB,kBAAkB;EAClB,mBAAmB;EACnB,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,mBAAmB;EACnB,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,yBAAyB;AAC3B;;AAEA;EACE,iBAAiB;EACjB,iBAAiB;EACjB,mBAAmB;EACnB,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,gBAAgB;AAClB;;AAEA,mCAAmC;AACnC;EACE,6DAA6D;EAC7D,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,iBAAiB;EACjB,iBAAiB;EACjB,mBAAmB;EACnB,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;EAClB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA,oCAAoC;AACpC;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,oBAAoB;EACpB,0BAA0B;EAC1B,6BAA6B;AAC/B;;AAEA;EACE,cAAc;EACd,4BAA4B;AAC9B;;AAEA,kDAAkD;AAClD;EACE,gBAAgB;EAChB,eAAe;EACf,cAAc;EACd,gBAAgB;EAChB,YAAY;EACZ,iCAAiC;AACnC;;AAEA,oDAAoD;AACpD;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,gBAAgB;EAChB,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,YAAY;EACZ,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA,2BAA2B;AAC3B;EACE,cAAc;AAChB;;AAEA,oEAAoE;;AAEpE;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,aAAa;EACb,8BAA8B;EAC9B,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,2CAA2C;EAC3C,YAAY;EACZ,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,kBAAkB;EAClB,6DAA6D;EAC7D,YAAY;EACZ,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,oCAAoC;EACpC,YAAY;EACZ,YAAY;EACZ,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,2BAA2B;AAC7B;;AAEA;EACE,qCAAqC;AACvC;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,SAAO;AACT;;AAEA,yBAAyB;AACzB;EACE,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,SAAS;EACT,eAAe;EACf,cAAc;EACd,gBAAgB;AAClB;;AAEA,mBAAmB;AACnB;EACE,6DAA6D;EAC7D,yBAAyB;EACzB,mBAAmB;EACnB,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,gBAAgB;EAChB,eAAe;EACf,cAAc;EACd,mBAAmB;EACnB,mBAAmB;EACnB,gCAAgC;AAClC;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,mBAAmB;EACnB,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,mBAAmB;EACnB,gBAAgB;EAChB,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA,kBAAkB;AAClB;EACE,gBAAgB;EAChB,aAAa;EACb,6DAA6D;EAC7D,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,mBAAmB;EACnB,mBAAmB;EACnB,iDAAiD;AACnD;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,QAAQ;AACV;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,SAAO;EACP,eAAe;EACf,aAAa;EACb,yCAAyC;AAC3C;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,kBAAkB;EAClB,aAAa;EACb,SAAS;AACX;;AAEA,sEAAsE;;AAEtE;EACE,6DAA6D;EAC7D,yBAAyB;AAC3B;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,eAAe;AACjB;;AAEA;EACE,SAAO;EACP,gBAAgB;EAChB,aAAa;EACb,uBAAuB;EACvB,SAAS;EACT,aAAa;EACb,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;EACf,iBAAiB;EACjB,0BAA0B;AAC5B;;AAEA;EACE,qBAAqB;EACrB,mBAAmB;AACrB;;AAEA;EACE,qBAAqB;EACrB,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,iBAAiB;EACjB,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;EACf,cAAc;EACd,yBAAyB;AAC3B;;AAEA,yEAAyE;;AAEzE;EACE,gBAAgB;EAChB,aAAa;EACb,6DAA6D;EAC7D,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,mBAAmB;AACrB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;EAClB,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,eAAe;EACf,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,yBAAyB;AAC3B;;AAEA;EACE,eAAe;EACf,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;EAClB,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,gBAAgB;EAChB,kBAAkB;EAClB,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,qBAAqB;AACvB;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,SAAS;EACT,iBAAiB;EACjB,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;EACf,cAAc;EACd,yBAAyB;AAC3B;;AAEA,mFAAmF;;AAEnF;EACE,6DAA6D;EAC7D,yBAAyB;AAC3B;;AAEA;EACE,cAAc;EACd,mBAAmB;AACrB;;AAEA,kBAAkB;AAClB;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,kBAAkB;EAClB,iBAAiB;EACjB,kBAAkB;EAClB,mBAAmB;EACnB,yBAAyB;AAC3B;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,iBAAiB;AACnB;;AAEA,yBAAyB;AACzB;EACE,iBAAiB;EACjB,kBAAkB;EAClB,gBAAgB;EAChB,yBAAyB;AAC3B;;AAEA;EACE,WAAW;EACX,yBAAyB;AAC3B;;AAEA;EACE,kBAAkB;EAClB,6DAA6D;EAC7D,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,gBAAgB;EAChB,gCAAgC;AAClC;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,gCAAgC;EAChC,sBAAsB;AACxB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,WAAW;AACb;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,cAAc;EACd,eAAe;AACjB;;AAEA,2BAA2B;AAC3B;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,kBAAkB;EAClB,iBAAiB;EACjB,kBAAkB;EAClB,gBAAgB;EAChB,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;EACjB,6DAA6D;EAC7D,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA,wEAAwE;;AAExE;EACE,YAAY;AACd;;AAEA;EACE,6DAA6D;AAC/D;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,kBAAkB;EAClB,6DAA6D;EAC7D,yBAAyB;EACzB,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA,oBAAoB;AACpB;EACE,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,mBAAmB;EACnB,mBAAmB;EACnB,gCAAgC;AAClC;;AAEA;EACE,aAAa;EACb,SAAS;EACT,eAAe;EACf,gCAAgC;AAClC;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,6DAA6D;EAC7D,YAAY;EACZ,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,SAAO;AACT;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,eAAe;EACf,cAAc;EACd,kBAAkB;EAClB,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,eAAe;EACf,cAAc;EACd,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,eAAe;EACf,cAAc;EACd,gBAAgB;EAChB,iBAAiB;EACjB,mBAAmB;EACnB,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;EAChB,mBAAmB;EACnB,kBAAkB;EAClB,yCAAyC;EACzC,eAAe;AACjB;;AAEA,oBAAoB;AACpB;EACE,6DAA6D;EAC7D,mBAAmB;EACnB,aAAa;EACb,YAAY;AACd;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,mBAAmB;EACnB,iDAAiD;AACnD;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,8CAA8C;EAC9C,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,aAAa;EACb,kBAAkB;EAClB,iBAAiB;EACjB,qCAAqC;EACrC,kBAAkB;AACpB;;AAEA,+EAA+E;;AAE/E;EACE,mBAAmB;EACnB,yBAAyB;EACzB,mBAAmB;EACnB,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,mBAAmB;AACrB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA,oCAAoC;AACpC;EACE,aAAa;EACb,8BAA8B;EAC9B,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,SAAS;EACT,kBAAkB;EAClB,iBAAiB;EACjB,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;EACf,0BAA0B;AAC5B;;AAEA;EACE,qBAAqB;EACrB,mBAAmB;AACrB;;AAEA;EACE,qBAAqB;EACrB,6DAA6D;EAC7D,8CAA8C;AAChD;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,SAAO;AACT;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,kBAAkB;AACpB;;AAEA,wBAAwB;AACxB;EACE,aAAa;EACb,uBAAuB;EACvB,QAAQ;EACR,kBAAkB;EAClB,mBAAmB;EACnB,kBAAkB;EAClB,yBAAyB;AAC3B;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA,uEAAuE;;AAEvE,iEAAiE;AACjE;EACE,kBAAkB;AACpB;;AAEA;EACE,eAAe;AACjB;;AAEA;;;EAGE,gBAAgB;EAChB,eAAe;EACf,YAAY;EACZ,YAAY;EACZ,sBAAsB;AACxB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,iBAAiB;AACnB;;AAEA;;;EAGE,UAAU;AACZ;;AAEA,gDAAgD;AAChD;EACE,6DAA6D;AAC/D;;AAEA;EACE,6DAA6D;AAC/D;;AAEA,6BAA6B;AAC7B;EACE,eAAe;EACf,2BAA2B;AAC7B;;AAEA;EACE,wEAAwE;AAC1E;;AAEA;EACE,qBAAqB;EACrB,UAAU;AACZ;;AAEA,4DAA4D;;AAE5D;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,8BAA8B;EAC9B,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;EACb,2BAA2B;AAC7B;;AAEA;EACE,OAAO,UAAU,EAAE;EACnB,KAAK,UAAU,EAAE;AACnB;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,UAAU;EACV,gBAAgB;EAChB,gBAAgB;EAChB,gBAAgB;EAChB,0CAA0C;EAC1C,4BAA4B;AAC9B;;AAEA;EACE,OAAO,2BAA2B,EAAE,UAAU,EAAE;EAChD,KAAK,wBAAwB,EAAE,UAAU,EAAE;AAC7C;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,kBAAkB;EAClB,6DAA6D;EAC7D,YAAY;EACZ,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,oCAAoC;EACpC,YAAY;EACZ,YAAY;EACZ,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,aAAa;EACb,gBAAgB;EAChB,6BAA6B;AAC/B;;AAEA;EACE,mBAAmB;EACnB,oBAAoB;EACpB,gCAAgC;AAClC;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,iBAAiB;EACjB,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;EACnB,8BAA8B;EAC9B,iBAAiB;EACjB,eAAe;EACf,cAAc;EACd,eAAe;EACf,0BAA0B;AAC5B;;AAEA,kBAAkB;AAClB;EACE,6DAA6D;EAC7D,yBAAyB;EACzB,kBAAkB;EAClB,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA,qBAAqB;AACrB;EACE,6DAA6D;EAC7D,yBAAyB;EACzB,kBAAkB;EAClB,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA,sBAAsB;AACtB;EACE,6DAA6D;EAC7D,yBAAyB;EACzB,kBAAkB;EAClB,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,8BAA8B;EAC9B,iBAAiB;EACjB,gBAAgB;EAChB,0BAA0B;AAC5B;;AAEA,mCAAmC;AACnC;EACE,WAAW;EACX,yBAAyB;EACzB,gBAAgB;EAChB,eAAe;AACjB;;AAEA;;EAEE,iBAAiB;EACjB,gBAAgB;EAChB,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,cAAc;AAChB;;AAEA,gBAAgB;AAChB;EACE,YAAY;AACd;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,YAAY;EACZ,gBAAgB;EAChB,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;AACjB;;AAEA,oBAAoB;AACpB;EACE,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;AACjB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,yBAAyB;EACzB,iBAAiB;EACjB,0BAA0B;AAC5B;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,YAAY;AACd;;AAEA;EACE,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,cAAc;AAChB;;AAEA,kBAAkB;AAClB;;EAEE,eAAe;EACf,YAAY;AACd;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;EACf,iBAAiB;EACjB,eAAe;EACf,WAAW;AACb;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,6CAA6C;AAC/C;;AAEA,oBAAoB;AACpB;EACE,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;EACf,WAAW;AACb;;AAEA;EACE,aAAa;EACb,qBAAqB;AACvB;;AAEA;EACE,qBAAqB;EACrB,gBAAgB;EAChB,cAAc;EACd,gBAAgB;EAChB,eAAe;AACjB;;AAEA,mBAAmB;AACnB;;EAEE,YAAY;EACZ,kBAAkB;AACpB;;AAEA;;EAEE,oBAAoB;EACpB,kBAAkB;EAClB,SAAS;EACT,SAAS;EACT,2BAA2B;EAC3B,mBAAmB;EACnB,YAAY;EACZ,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,YAAY;EACZ,YAAY;EACZ,yCAAyC;AAC3C;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA,oBAAoB;AACpB;EACE,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA,yBAAyB;AACzB;;EAEE,cAAc;EACd,gBAAgB;AAClB;;AAEA,kCAAkC;AAClC;EACE,cAAc;EACd,gBAAgB;EAChB,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,qBAAqB;EACrB,cAAc;EACd,gBAAgB;EAChB,gBAAgB;EAChB,mBAAmB;EACnB,cAAc;EACd,kBAAkB;EAClB,yBAAyB;EACzB,sBAAsB;AACxB;;AAEA,kCAAkC;AAClC;EACE,qBAAqB;EACrB,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,mBAAmB;EACnB,cAAc;EACd,kBAAkB;EAClB,yBAAyB;EACzB,sBAAsB;EACtB,gBAAgB;AAClB;;AAEA,sCAAsC;AACtC;EACE,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,2BAA2B;EAC3B,0CAA0C;AAC5C;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,YAAY;AACd;;AAEA;EACE,UAAU;AACZ;;AAEA,mCAAmC;AACnC;EACE,qBAAqB;EACrB,cAAc;EACd,gBAAgB;EAChB,gBAAgB;EAChB,kBAAkB;EAClB,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,yBAAyB;AAC3B;;AAEA,8BAA8B;AAC9B;EACE,8BAA8B;EAC9B,eAAe;EACf,gBAAgB;AAClB;;AAEA,gCAAgC;AAChC;EACE,YAAY;EACZ,eAAe;EACf,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,6DAA6D;EAC7D,YAAY;AACd;;AAEA;EACE,aAAa;EACb,gCAAgC;AAClC;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,cAAc;EACd,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,eAAe;EACf,cAAc;EACd,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,cAAc;AAChB;;AAEA,6BAA6B;AAC7B;EACE,mBAAmB;EACnB,kBAAkB;EAClB,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;EACnB,yBAAyB;AAC3B;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,QAAQ;EACR,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,kBAAkB;EAClB,yBAAyB;AAC3B;;AAEA,qBAAqB;AACrB;EACE,aAAa;EACb,8BAA8B;EAC9B,cAAc;EACd,eAAe;EACf,iCAAiC;AACnC;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,mBAAmB;EACnB,iBAAiB;EACjB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,6DAA6D;EAC7D,mBAAmB;EACnB,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,kBAAkB;EAClB,iBAAiB;EACjB,cAAc;EACd,8BAA8B;EAC9B,eAAe;AACjB;;AAEA,oBAAoB;AACpB;EACE,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,yBAAyB;AAC3B;;AAEA,oBAAoB;AACpB;EACE,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,cAAc;EACd,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,8BAA8B;AAChC","sourcesContent":["/* src/components/Person/PersonEditPage.css */\n/* Same design as WizardAddPerson - single page edition */\n\n/* ===================== FULL PAGE LAYOUT ===================== */\n/* Covers only the lanes area - sidebar, tabs and scenario header remain visible */\n\n.person-edit-page {\n  position: fixed;\n  top: 120px;  /* Below: tabs (~50px) + scenario header (~70px) */\n  left: 230px;  /* After sidebar (220px) + small gap (10px) */\n  right: 10px;  /* Small margin */\n  bottom: 10px;  /* Small margin */\n  display: flex;\n  flex-direction: column;\n  background: #F8FAFC;\n  z-index: 1100;  /* Above the App save button (z-index: 1000) */\n  overflow: hidden;\n  border-radius: 10px;  /* Match lanes border-radius */\n  border: 1px solid #BDC3C7;  /* Match lanes border */\n  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.15);\n}\n\n@media (max-width: 768px) {\n  .person-edit-page {\n    left: 8px;\n    right: 8px;\n    top: 120px;\n    bottom: 8px;\n  }\n}\n\n/* Standalone mode - full page */\n.person-edit-page.standalone {\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  border-radius: 0;\n  border: none;\n}\n\n.edit-loading {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  height: 100%;\n  font-size: 16px;\n  color: #64748B;\n}\n\n/* ===================== TOPBAR ===================== */\n\n.person-edit-page .edit-topbar {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding: 12px 24px;\n  background: linear-gradient(135deg, #FF6F61 0%, #FF8A80 100%);\n  color: white;\n  flex-shrink: 0;\n}\n\n.person-edit-page .topbar-left {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n}\n\n.person-edit-page .topbar-left h3 {\n  margin: 0;\n  font-size: 16px;\n  font-weight: 600;\n}\n\n.person-edit-page .standalone-badge {\n  background: rgba(255,255,255,0.2);\n  padding: 4px 10px;\n  border-radius: 12px;\n  font-size: 11px;\n  font-weight: 500;\n}\n\n.person-edit-page .topbar-right {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n}\n\n.person-edit-page .save-btn {\n  padding: 8px 20px;\n  background: rgba(255,255,255,0.2);\n  border: 1px solid rgba(255,255,255,0.4);\n  color: white;\n  border-radius: 6px;\n  font-size: 13px;\n  font-weight: 600;\n  cursor: pointer;\n  transition: all 0.2s ease;\n  min-width: 110px;\n}\n\n.person-edit-page .save-btn:hover:not(:disabled) {\n  background: rgba(255,255,255,0.35);\n  transform: translateY(-1px);\n}\n\n.person-edit-page .save-btn:disabled {\n  cursor: wait;\n  opacity: 0.7;\n}\n\n/* Saving state - subtle pulse animation */\n.person-edit-page .save-btn.saving {\n  background: rgba(255,255,255,0.15);\n  animation: savingPulse 1s ease-in-out infinite;\n}\n\n@keyframes savingPulse {\n  0%, 100% { opacity: 0.7; }\n  50% { opacity: 1; }\n}\n\n/* Success state - brief green flash */\n.person-edit-page .save-btn.success {\n  background: rgba(16, 185, 129, 0.7);\n  border-color: rgba(16, 185, 129, 0.9);\n  animation: successFlash 0.4s ease-out;\n}\n\n@keyframes successFlash {\n  0% { transform: scale(1); box-shadow: 0 0 0 0 rgba(16, 185, 129, 0.6); }\n  50% { transform: scale(1.05); box-shadow: 0 0 20px 4px rgba(16, 185, 129, 0.4); }\n  100% { transform: scale(1); box-shadow: 0 0 0 0 rgba(16, 185, 129, 0); }\n}\n\n.person-edit-page .close-btn {\n  background: rgba(255, 255, 255, 0.2);\n  border: none;\n  font-size: 18px;\n  cursor: pointer;\n  color: white;\n  width: 28px;\n  height: 28px;\n  border-radius: 50%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  transition: background 0.2s;\n}\n\n.person-edit-page .close-btn:hover {\n  background: rgba(255, 255, 255, 0.3);\n}\n\n/* ===================== PERSON HEADER ROW ===================== */\n/* Two compact sections side by side */\n\n.person-edit-page .person-header-row {\n  display: grid;\n  grid-template-columns: 1fr 2fr;\n  gap: 16px;\n}\n\n.person-edit-page .form-section.compact {\n  padding: 14px 16px;\n}\n\n.person-edit-page .form-section.compact h4 {\n  margin: 0 0 10px 0;\n  font-size: 13px;\n  color: #64748B;\n  font-weight: 600;\n}\n\n/* Family section layout */\n.person-edit-page .family-row {\n  display: flex;\n  align-items: center;\n  gap: 16px;\n  flex-wrap: wrap;\n}\n\n/* Status chips - compact */\n.person-edit-page .status-chips {\n  display: flex;\n  gap: 4px;\n}\n\n.person-edit-page .status-chip {\n  width: 34px;\n  height: 34px;\n  border: 2px solid #E2E8F0;\n  border-radius: 8px;\n  background: white;\n  cursor: pointer;\n  transition: all 0.15s;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  padding: 0;\n}\n\n.person-edit-page .status-chip .chip-icon {\n  font-size: 16px;\n}\n\n.person-edit-page .status-chip:hover {\n  border-color: #FF6F61;\n  background: #FFF5F4;\n}\n\n.person-edit-page .status-chip.selected {\n  border-color: #FF6F61;\n  background: #FF6F61;\n}\n\n/* Children inline control */\n.person-edit-page .children-inline {\n  display: flex;\n  align-items: center;\n  gap: 6px;\n}\n\n.person-edit-page .children-inline .children-label {\n  font-size: 12px;\n  color: #64748B;\n  font-weight: 500;\n}\n\n.person-edit-page .children-inline .child-btn {\n  width: 26px;\n  height: 26px;\n  border: 1px solid #E2E8F0;\n  border-radius: 6px;\n  background: white;\n  font-size: 14px;\n  font-weight: 600;\n  color: #64748B;\n  cursor: pointer;\n  transition: all 0.15s;\n}\n\n.person-edit-page .children-inline .child-btn:hover:not(:disabled) {\n  border-color: #FF6F61;\n  color: #FF6F61;\n}\n\n.person-edit-page .children-inline .child-btn:disabled {\n  opacity: 0.4;\n  cursor: not-allowed;\n}\n\n.person-edit-page .children-inline .child-count {\n  font-size: 15px;\n  font-weight: 600;\n  min-width: 18px;\n  text-align: center;\n}\n\n/* Single parent checkbox */\n.person-edit-page .single-parent-check {\n  display: flex;\n  align-items: center;\n  gap: 5px;\n  font-size: 12px;\n  color: #64748B;\n  cursor: pointer;\n}\n\n.person-edit-page .single-parent-check input {\n  width: 14px;\n  height: 14px;\n  accent-color: #FF6F61;\n}\n\n/* Fiscal badge */\n.person-edit-page .fiscal-badge {\n  display: flex;\n  align-items: baseline;\n  gap: 3px;\n  padding: 5px 10px;\n  background: linear-gradient(135deg, #FF6F61 0%, #FF8A80 100%);\n  border-radius: 16px;\n  color: white;\n  margin-left: auto;\n}\n\n.person-edit-page .fiscal-badge .fiscal-value {\n  font-size: 15px;\n  font-weight: 700;\n}\n\n.person-edit-page .fiscal-badge .fiscal-unit {\n  font-size: 10px;\n  font-weight: 500;\n  opacity: 0.9;\n}\n\n/* ===================== BODY ===================== */\n\n.person-edit-page .edit-body {\n  flex: 1;\n  overflow-y: auto;\n  padding: 16px 20px;\n  display: grid;\n  grid-template-columns: 1fr;\n  gap: 16px;\n  align-content: start;\n}\n\n/* ===================== FORM SECTIONS ===================== */\n\n.person-edit-page .form-section {\n  background: white;\n  border-radius: 12px;\n  padding: 20px;\n  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.06);\n}\n\n.person-edit-page .form-section h4 {\n  margin: 0 0 16px 0;\n  font-size: 15px;\n  font-weight: 600;\n  color: #1E293B;\n  display: flex;\n  align-items: center;\n  gap: 10px;\n}\n\n.person-edit-page .section-icon {\n  width: 24px;\n  height: 24px;\n  border-radius: 50%;\n  background: #FF6F61;\n  color: white;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-size: 12px;\n  font-weight: 700;\n}\n\n/* Sections take full width in single-column layout */\n.person-edit-page .form-section.incomes-section,\n.person-edit-page .form-section.summary-section {\n  /* Already full width in 1-column grid */\n}\n\n/* ===================== FORM ELEMENTS ===================== */\n\n.person-edit-page .form-row {\n  display: flex;\n  gap: 16px;\n  margin-bottom: 16px;\n}\n\n.person-edit-page .form-group {\n  flex: 1;\n}\n\n.person-edit-page .form-group label {\n  display: block;\n  font-size: 12px;\n  font-weight: 500;\n  color: #64748B;\n  margin-bottom: 6px;\n}\n\n.person-edit-page .form-group input[type=\"text\"],\n.person-edit-page .form-group input[type=\"number\"] {\n  width: 100%;\n  padding: 10px 12px;\n  border: 1px solid #E2E8F0;\n  border-radius: 8px;\n  font-size: 14px;\n  transition: border-color 0.2s;\n  box-sizing: border-box;\n}\n\n.person-edit-page .form-group input:focus {\n  outline: none;\n  border-color: #FF6F61;\n}\n\n/* ===================== STATUS CARDS ===================== */\n\n.person-edit-page .status-cards {\n  display: flex;\n  gap: 8px;\n  flex-wrap: wrap;\n}\n\n.person-edit-page .status-card {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: 4px;\n  padding: 12px 16px;\n  border: 2px solid #E2E8F0;\n  border-radius: 10px;\n  cursor: pointer;\n  transition: all 0.2s;\n  min-width: 70px;\n}\n\n.person-edit-page .status-card:hover {\n  border-color: #FF6F61;\n  background: #FFF5F4;\n}\n\n.person-edit-page .status-card.selected {\n  border-color: #FF6F61;\n  background: #FF6F61;\n  color: white;\n}\n\n.person-edit-page .status-card .status-icon {\n  font-size: 20px;\n}\n\n.person-edit-page .status-card .status-label {\n  font-size: 11px;\n  font-weight: 500;\n}\n\n/* ===================== CHILDREN CONTROL ===================== */\n\n.person-edit-page .children-control {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n}\n\n.person-edit-page .children-btn {\n  width: 36px;\n  height: 36px;\n  border: 2px solid #E2E8F0;\n  border-radius: 8px;\n  background: white;\n  font-size: 18px;\n  font-weight: 600;\n  color: #64748B;\n  cursor: pointer;\n  transition: all 0.2s;\n}\n\n.person-edit-page .children-btn:hover:not(:disabled) {\n  border-color: #FF6F61;\n  color: #FF6F61;\n}\n\n.person-edit-page .children-btn:disabled {\n  opacity: 0.4;\n  cursor: not-allowed;\n}\n\n.person-edit-page .children-count {\n  font-size: 18px;\n  font-weight: 600;\n  min-width: 24px;\n  text-align: center;\n}\n\n/* ===================== CHECKBOX ===================== */\n\n.person-edit-page .checkbox-group {\n  margin-top: 8px;\n}\n\n.person-edit-page .checkbox-label {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  cursor: pointer;\n  font-size: 14px;\n}\n\n.person-edit-page .checkbox-label input[type=\"checkbox\"] {\n  width: 16px;\n  height: 16px;\n  accent-color: #FF6F61;\n}\n\n/* ===================== FISCAL PARTS DISPLAY ===================== */\n\n.person-edit-page .fiscal-parts-display {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: 12px 16px;\n  background: #F1F5F9;\n  border-radius: 8px;\n  margin-top: 12px;\n}\n\n.person-edit-page .fiscal-parts-display .label {\n  font-size: 13px;\n  color: #64748B;\n}\n\n.person-edit-page .fiscal-parts-display .parts {\n  font-size: 16px;\n  font-weight: 700;\n  color: #FF6F61;\n}\n\n/* ===================== INCOME ADD SECTION ===================== */\n\n.person-edit-page .income-add-section {\n  margin-bottom: 20px;\n}\n\n.person-edit-page .income-category-row {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  margin-bottom: 10px;\n}\n\n.person-edit-page .category-label {\n  font-size: 12px;\n  font-weight: 600;\n  color: #64748B;\n  min-width: 100px;\n}\n\n.person-edit-page .category-types {\n  display: flex;\n  gap: 6px;\n  flex-wrap: wrap;\n}\n\n.person-edit-page .add-type-btn {\n  display: flex;\n  align-items: center;\n  gap: 6px;\n  padding: 6px 12px;\n  border: 1px solid #E2E8F0;\n  border-radius: 20px;\n  background: white;\n  cursor: pointer;\n  transition: all 0.2s;\n  font-size: 12px;\n}\n\n.person-edit-page .add-type-btn:hover {\n  border-color: #94A3B8;\n  background: #F8FAFC;\n}\n\n.person-edit-page .add-type-btn .btn-icon {\n  width: 20px;\n  height: 20px;\n  border-radius: 50%;\n  color: white;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-size: 10px;\n  font-weight: 700;\n}\n\n.person-edit-page .add-type-btn .btn-label {\n  color: #475569;\n  font-weight: 500;\n}\n\n/* ===================== INCOME SOURCES LIST ===================== */\n\n.person-edit-page .income-sources-list {\n  display: flex;\n  flex-direction: column;\n  gap: 12px;\n}\n\n.person-edit-page .no-sources-hint {\n  text-align: center;\n  padding: 40px 20px;\n  color: #94A3B8;\n}\n\n.person-edit-page .no-sources-hint p {\n  margin: 0;\n  font-size: 14px;\n}\n\n/* ===================== INCOME SOURCE CARD ===================== */\n\n.person-edit-page .income-source-card {\n  border: 1px solid #E2E8F0;\n  border-radius: 10px;\n  overflow: hidden;\n  background: white;\n}\n\n.person-edit-page .income-source-card.expanded {\n  border-color: #CBD5E1;\n  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.04);\n}\n\n.person-edit-page .income-source-card.needs-dates {\n  border-style: dashed;\n}\n\n.person-edit-page .source-header {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  padding: 12px 14px;\n  background: #F8FAFC;\n  cursor: pointer;\n}\n\n.person-edit-page .source-icon {\n  width: 28px;\n  height: 28px;\n  border-radius: 6px;\n  color: white;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-size: 11px;\n  font-weight: 700;\n  flex-shrink: 0;\n}\n\n.person-edit-page .source-type {\n  font-size: 13px;\n  font-weight: 600;\n  color: #334155;\n  white-space: nowrap;\n}\n\n.person-edit-page .source-label-input {\n  flex: 1;\n  min-width: 100px;\n  padding: 6px 10px;\n  border: 1px solid #E2E8F0;\n  border-radius: 6px;\n  font-size: 12px;\n  background: white;\n}\n\n.person-edit-page .source-label-input:focus {\n  outline: none;\n  border-color: #FF6F61;\n}\n\n.person-edit-page .date-sep {\n  font-size: 11px;\n  color: #94A3B8;\n}\n\n.person-edit-page .source-date {\n  padding: 5px 8px;\n  border: 1px solid #E2E8F0;\n  border-radius: 6px;\n  font-size: 12px;\n  background: white;\n  cursor: pointer;\n}\n\n.person-edit-page .source-date:focus {\n  outline: none;\n  border-color: #FF6F61;\n}\n\n.person-edit-page .expand-icon {\n  font-size: 10px;\n  color: #94A3B8;\n  transition: transform 0.2s;\n}\n\n.person-edit-page .expand-icon.expanded {\n  transform: rotate(180deg);\n}\n\n.person-edit-page .remove-source-btn {\n  width: 24px;\n  height: 24px;\n  border: none;\n  border-radius: 50%;\n  background: #FEE2E2;\n  color: #EF4444;\n  font-size: 14px;\n  cursor: pointer;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  transition: all 0.2s;\n}\n\n.person-edit-page .remove-source-btn:hover {\n  background: #EF4444;\n  color: white;\n}\n\n.person-edit-page .dates-hint {\n  padding: 12px 14px;\n  font-size: 12px;\n  color: #94A3B8;\n  font-style: italic;\n}\n\n/* ===================== SOURCE YEARS TABLE ===================== */\n\n.person-edit-page .source-years-table {\n  padding: 0;\n}\n\n.person-edit-page .source-years-table table {\n  width: 100%;\n  border-collapse: collapse;\n}\n\n.person-edit-page .source-years-table th {\n  padding: 10px 12px;\n  background: #F1F5F9;\n  font-size: 11px;\n  font-weight: 600;\n  color: #64748B;\n  text-align: left;\n  border-bottom: 1px solid #E2E8F0;\n}\n\n.person-edit-page .source-years-table td {\n  padding: 10px 12px;\n  font-size: 13px;\n  border-bottom: 1px solid #F1F5F9;\n}\n\n.person-edit-page .source-years-table tr:last-child td {\n  border-bottom: none;\n}\n\n.person-edit-page .td-year {\n  font-weight: 600;\n  color: #334155;\n  width: 60px;\n}\n\n.person-edit-page .td-brut {\n  width: 140px;\n}\n\n.person-edit-page .input-wrapper {\n  display: flex;\n  align-items: center;\n  border: 1px solid #E2E8F0;\n  border-radius: 6px;\n  overflow: hidden;\n  background: white;\n}\n\n.person-edit-page .input-wrapper.needs-input {\n  border-color: #FCD34D;\n  background: #FFFBEB;\n}\n\n.person-edit-page .input-wrapper input {\n  flex: 1;\n  border: none;\n  padding: 8px 10px;\n  font-size: 13px;\n  background: transparent;\n  width: 80px;\n}\n\n.person-edit-page .input-wrapper input:focus {\n  outline: none;\n}\n\n.person-edit-page .input-suffix {\n  padding: 0 10px;\n  font-size: 12px;\n  color: #94A3B8;\n  background: #F8FAFC;\n}\n\n.person-edit-page .td-detail {\n  width: 40px;\n  text-align: center;\n}\n\n.person-edit-page .detail-btn {\n  width: 28px;\n  height: 28px;\n  border: 1px solid #E2E8F0;\n  border-radius: 6px;\n  background: white;\n  cursor: pointer;\n  font-size: 14px;\n  transition: all 0.2s;\n}\n\n.person-edit-page .detail-btn:hover {\n  border-color: #FF6F61;\n  color: #FF6F61;\n}\n\n.person-edit-page .detail-btn.has-detail {\n  background: #DCFCE7;\n  border-color: #22C55E;\n  color: #16A34A;\n}\n\n.person-edit-page .auto-value {\n  color: #64748B;\n  font-size: 13px;\n}\n\n/* ===================== DANSMAPOCHE SUMMARY ===================== */\n\n.person-edit-page .dansmapoche-years {\n  display: flex;\n  gap: 16px;\n  flex-wrap: wrap;\n}\n\n.person-edit-page .dansmapoche-year-card {\n  flex: 1 1 280px;\n  min-width: 240px;\n  max-width: 400px;\n  background: linear-gradient(135deg, #059669 0%, #10b981 100%);\n  border-radius: 12px;\n  padding: 16px;\n  color: white;\n}\n\n.person-edit-page .year-label {\n  font-size: 20px;\n  font-weight: 700;\n  margin-bottom: 12px;\n}\n\n.person-edit-page .year-breakdown {\n  display: flex;\n  flex-direction: column;\n  gap: 6px;\n}\n\n.person-edit-page .breakdown-row {\n  display: flex;\n  justify-content: space-between;\n  font-size: 13px;\n}\n\n.person-edit-page .row-label {\n  opacity: 0.9;\n}\n\n.person-edit-page .row-value {\n  font-weight: 500;\n}\n\n.person-edit-page .row-value.negative {\n  color: #FCA5A5;\n}\n\n.person-edit-page .breakdown-row.dansmapoche-row {\n  margin-top: 8px;\n  padding-top: 8px;\n  border-top: 1px solid rgba(255,255,255,0.2);\n}\n\n.person-edit-page .row-value.highlight {\n  font-size: 18px;\n  font-weight: 700;\n}\n\n.person-edit-page .monthly-equivalent {\n  margin-top: 12px;\n  font-size: 12px;\n  opacity: 0.8;\n  text-align: center;\n}\n\n.person-edit-page .no-data-message {\n  text-align: center;\n  padding: 30px;\n  color: #94A3B8;\n}\n\n.person-edit-page .no-data-message p {\n  margin: 0;\n  font-size: 14px;\n}\n\n/* ===================== LINKED ENTITY INCOME ===================== */\n\n.person-edit-page .linked-entity-banner {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  padding: 10px 16px;\n  background: linear-gradient(135deg, #FFF3E0 0%, #FFE0B2 100%);\n  border: 1px solid #FFB74D;\n  border-radius: 6px;\n  margin-bottom: 12px;\n  font-size: 13px;\n  color: #E65100;\n}\n\n.person-edit-page .linked-entity-banner .link-icon {\n  font-size: 16px;\n}\n\n.person-edit-page .linked-entity-banner .readonly-badge {\n  margin-left: auto;\n  padding: 2px 8px;\n  background: #FF9800;\n  color: white;\n  border-radius: 4px;\n  font-size: 11px;\n  font-weight: 600;\n  text-transform: uppercase;\n}\n\n.person-edit-page .linked-entity-banner .editable-badge {\n  margin-left: auto;\n  padding: 3px 10px;\n  background: #4CAF50;\n  color: white;\n  border-radius: 4px;\n  font-size: 11px;\n  font-weight: 600;\n}\n\n/* Dividend banner - golden theme */\n.person-edit-page .linked-entity-banner.dividend-banner {\n  background: linear-gradient(135deg, #FEF3C7 0%, #FDE68A 100%);\n  color: #92400E;\n  border-color: #F59E0B;\n}\n\n.person-edit-page .linked-entity-banner .info-badge {\n  margin-left: auto;\n  padding: 3px 10px;\n  background: #F59E0B;\n  color: white;\n  border-radius: 4px;\n  font-size: 11px;\n  font-weight: 600;\n}\n\n.person-edit-page tr.from-entity {\n  background: #FFFDE7;\n}\n\n.person-edit-page .readonly-value {\n  padding: 8px 12px;\n  background: #F5F5F5;\n  border: 1px solid #E0E0E0;\n  border-radius: 4px;\n  color: #616161;\n  font-weight: 500;\n}\n\n.person-edit-page .readonly-value.clickable {\n  cursor: pointer;\n  transition: all 0.2s ease;\n}\n\n.person-edit-page .readonly-value.clickable:hover {\n  background: #EEEEEE;\n  border-color: #BDBDBD;\n}\n\n/* Prorata info for linked incomes */\n.person-edit-page .prorata-info {\n  font-size: 11px;\n  color: #9E9E9E;\n  font-weight: 400;\n}\n\n.person-edit-page .prorata-info.clickable {\n  color: #1976D2;\n  cursor: pointer;\n  pointer-events: auto;\n  text-decoration: underline;\n  text-decoration-style: dotted;\n}\n\n.person-edit-page .prorata-info.clickable:hover {\n  color: #1565C0;\n  text-decoration-style: solid;\n}\n\n/* Legacy prorata badge - kept for compatibility */\n.person-edit-page .prorata-badge {\n  margin-left: 6px;\n  font-size: 11px;\n  color: #FF9800;\n  font-weight: 500;\n  cursor: help;\n  border-bottom: 1px dotted #FF9800;\n}\n\n/* Calculation info icon for entity-linked incomes */\n.person-edit-page .calc-info-icon {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  margin-left: 6px;\n  width: 18px;\n  height: 18px;\n  background: #2196F3;\n  color: white;\n  border-radius: 50%;\n  font-size: 11px;\n  font-weight: 600;\n  cursor: help;\n  transition: all 0.2s ease;\n}\n\n.person-edit-page .calc-info-icon:hover {\n  background: #1976D2;\n  transform: scale(1.1);\n}\n\n.person-edit-page .calc-info-icon.small {\n  width: 16px;\n  height: 16px;\n  font-size: 10px;\n  background: #9E9E9E;\n}\n\n.person-edit-page .calc-info-icon.small:hover {\n  background: #757575;\n}\n\n.person-edit-page .readonly-value.with-detail {\n  display: flex;\n  align-items: center;\n  gap: 4px;\n}\n\n/* Negative value styling */\n.person-edit-page .auto-value.neg {\n  color: #D32F2F;\n}\n\n/* ===================== CALCULATION POPOVER ===================== */\n\n.calc-popover-overlay {\n  position: fixed;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  z-index: 2000;\n  background: rgba(0, 0, 0, 0.3);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.calc-popover {\n  background: white;\n  border-radius: 12px;\n  box-shadow: 0 10px 40px rgba(0, 0, 0, 0.25);\n  width: 580px;\n  max-width: 90vw;\n  max-height: 85vh;\n  overflow: hidden;\n  display: flex;\n  flex-direction: column;\n}\n\n.calc-popover-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding: 14px 18px;\n  background: linear-gradient(135deg, #1565C0 0%, #1976D2 100%);\n  color: white;\n  font-weight: 600;\n  font-size: 15px;\n}\n\n.calc-popover-header button {\n  background: rgba(255, 255, 255, 0.2);\n  border: none;\n  color: white;\n  width: 26px;\n  height: 26px;\n  border-radius: 50%;\n  cursor: pointer;\n  font-size: 18px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  transition: background 0.2s;\n}\n\n.calc-popover-header button:hover {\n  background: rgba(255, 255, 255, 0.35);\n}\n\n.calc-popover-body {\n  padding: 20px 24px;\n  overflow-y: auto;\n  flex: 1;\n}\n\n/* Explanation sections */\n.calc-explanation {\n  margin-bottom: 12px;\n}\n\n.explanation-title {\n  font-weight: 600;\n  font-size: 13px;\n  color: #1976D2;\n  margin-bottom: 4px;\n}\n\n.calc-explanation p {\n  margin: 0;\n  font-size: 13px;\n  color: #475569;\n  line-height: 1.5;\n}\n\n/* Exercice cards */\n.calc-exercice {\n  background: linear-gradient(135deg, #F8FAFC 0%, #F1F5F9 100%);\n  border: 1px solid #E2E8F0;\n  border-radius: 10px;\n  padding: 14px;\n  margin-bottom: 12px;\n}\n\n.exercice-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  font-weight: 600;\n  font-size: 13px;\n  color: #334155;\n  margin-bottom: 10px;\n  padding-bottom: 8px;\n  border-bottom: 1px solid #CBD5E1;\n}\n\n.exercice-days {\n  font-size: 11px;\n  font-weight: 500;\n  color: #64748B;\n  background: #E2E8F0;\n  padding: 2px 8px;\n  border-radius: 4px;\n}\n\n.calc-detail-row {\n  margin-bottom: 8px;\n}\n\n.detail-line {\n  display: flex;\n  justify-content: space-between;\n  font-size: 12px;\n  margin-bottom: 2px;\n}\n\n.detail-label {\n  color: #64748B;\n}\n\n.detail-value {\n  color: #334155;\n  font-weight: 500;\n}\n\n.detail-line.formula {\n  font-size: 11px;\n  color: #059669;\n  background: #ECFDF5;\n  padding: 4px 8px;\n  border-radius: 4px;\n  margin-top: 4px;\n}\n\n.detail-line.formula span:first-child {\n  color: #047857;\n}\n\n.detail-line.formula strong {\n  color: #047857;\n}\n\n/* Total section */\n.calc-total {\n  margin-top: 16px;\n  padding: 14px;\n  background: linear-gradient(135deg, #1976D2 0%, #1565C0 100%);\n  border-radius: 10px;\n  color: white;\n}\n\n.total-header {\n  font-weight: 600;\n  font-size: 14px;\n  margin-bottom: 10px;\n  padding-bottom: 8px;\n  border-bottom: 1px solid rgba(255, 255, 255, 0.3);\n}\n\n.total-row {\n  display: flex;\n  justify-content: space-between;\n  font-size: 13px;\n  margin-bottom: 6px;\n}\n\n.total-row.with-formula {\n  flex-wrap: wrap;\n  gap: 4px;\n}\n\n.total-label {\n  min-width: 90px;\n}\n\n.total-formula {\n  flex: 1;\n  font-size: 12px;\n  opacity: 0.85;\n  font-family: 'Monaco', 'Menlo', monospace;\n}\n\n.total-row:last-child {\n  margin-bottom: 0;\n}\n\n.total-value {\n  font-weight: 700;\n  font-size: 14px;\n}\n\n.calc-empty {\n  color: #94A3B8;\n  font-style: italic;\n  text-align: center;\n  padding: 30px;\n  margin: 0;\n}\n\n/* ===================== FISCAL OPTION SECTION ===================== */\n\n.fiscal-option-section {\n  background: linear-gradient(135deg, #f0f9ff 0%, #e0f2fe 100%);\n  border: 1px solid #0ea5e9;\n}\n\n.fiscal-option-section h4 {\n  color: #0369a1;\n}\n\n.fiscal-option-row {\n  display: flex;\n  gap: 16px;\n  flex-wrap: wrap;\n}\n\n.fiscal-option {\n  flex: 1;\n  min-width: 220px;\n  display: flex;\n  align-items: flex-start;\n  gap: 10px;\n  padding: 12px;\n  border: 2px solid #bae6fd;\n  border-radius: 8px;\n  cursor: pointer;\n  background: white;\n  transition: all 0.15s ease;\n}\n\n.fiscal-option:hover {\n  border-color: #7dd3fc;\n  background: #f0f9ff;\n}\n\n.fiscal-option.selected {\n  border-color: #0284c7;\n  background: #e0f2fe;\n}\n\n.fiscal-option input[type=\"radio\"] {\n  margin-top: 2px;\n  accent-color: #0284c7;\n}\n\n.fiscal-option-content {\n  display: flex;\n  flex-direction: column;\n  gap: 2px;\n}\n\n.fiscal-option-label {\n  font-weight: 600;\n  color: #0c4a6e;\n  font-size: 13px;\n}\n\n.fiscal-option-desc {\n  font-size: 11px;\n  color: #0369a1;\n  line-height: 1.3;\n}\n\n.fiscal-option-info {\n  margin-top: 12px;\n  margin-bottom: 0;\n  padding: 8px 12px;\n  background: white;\n  border-radius: 6px;\n  font-size: 12px;\n  color: #0369a1;\n  border: 1px solid #bae6fd;\n}\n\n/* ===================== DISPENSE ACOMPTE SECTION ===================== */\n\n.dispense-section {\n  margin-top: 16px;\n  padding: 14px;\n  background: linear-gradient(135deg, #fefce8 0%, #fef3c7 100%);\n  border: 1px solid #f59e0b;\n  border-radius: 8px;\n}\n\n.dispense-header {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  margin-bottom: 12px;\n}\n\n.dispense-icon {\n  font-size: 16px;\n}\n\n.dispense-title {\n  font-size: 14px;\n  font-weight: 600;\n  color: #92400e;\n}\n\n.dispense-eligibility {\n  background: white;\n  border-radius: 6px;\n  padding: 10px 12px;\n  margin-bottom: 12px;\n}\n\n.eligibility-row {\n  display: flex;\n  justify-content: space-between;\n  font-size: 12px;\n  color: #78350f;\n  margin-bottom: 4px;\n}\n\n.eligibility-value {\n  font-weight: 600;\n}\n\n.eligibility-status {\n  margin-top: 8px;\n  padding: 6px 10px;\n  border-radius: 4px;\n  font-size: 12px;\n  font-weight: 600;\n}\n\n.eligibility-status.eligible {\n  background: #ecfdf5;\n  color: #059669;\n  border: 1px solid #a7f3d0;\n}\n\n.eligibility-status.not-eligible {\n  background: #fef2f2;\n  color: #dc2626;\n  border: 1px solid #fecaca;\n}\n\n.eligibility-deadline {\n  margin-top: 8px;\n  font-size: 12px;\n  color: #92400e;\n}\n\n.eligibility-deadline strong {\n  color: #dc2626;\n}\n\n.dispense-companies {\n  background: white;\n  border-radius: 6px;\n  padding: 10px 12px;\n  margin-bottom: 12px;\n}\n\n.dispense-companies-label {\n  font-size: 12px;\n  font-weight: 600;\n  color: #78350f;\n  margin-bottom: 8px;\n}\n\n.dispense-company-option {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  padding: 6px 8px;\n  border-radius: 4px;\n  cursor: pointer;\n  margin-bottom: 4px;\n}\n\n.dispense-company-option:hover {\n  background: #fef3c7;\n}\n\n.dispense-company-option input[type=\"checkbox\"] {\n  width: 16px;\n  height: 16px;\n  accent-color: #f59e0b;\n}\n\n.dispense-company-name {\n  font-size: 13px;\n  color: #1f2937;\n}\n\n.dispense-dividend-year {\n  font-size: 11px;\n  color: #6b7280;\n  margin-left: 4px;\n}\n\n.dispense-info {\n  margin: 0;\n  padding: 8px 10px;\n  background: white;\n  border-radius: 4px;\n  font-size: 11px;\n  color: #92400e;\n  border: 1px solid #fcd34d;\n}\n\n/* ===================== CAPITAL INCOME (DIVIDENDS) SECTION ===================== */\n\n.capital-income-section {\n  background: linear-gradient(135deg, #fefce8 0%, #fef3c7 100%);\n  border: 1px solid #f59e0b;\n}\n\n.capital-income-section h4 {\n  color: #92400e;\n  margin-bottom: 16px;\n}\n\n/* Source header */\n.capital-source-header {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  padding: 10px 14px;\n  background: white;\n  border-radius: 8px;\n  margin-bottom: 12px;\n  border: 1px solid #fcd34d;\n}\n\n.capital-source-icon {\n  font-size: 16px;\n}\n\n.capital-source-name {\n  font-size: 13px;\n  color: #78350f;\n}\n\n.capital-source-name strong {\n  color: #92400e;\n}\n\n.capital-source-percent {\n  font-size: 12px;\n  color: #a16207;\n  margin-left: auto;\n}\n\n/* Capital income table */\n.capital-income-table {\n  background: white;\n  border-radius: 8px;\n  overflow: hidden;\n  border: 1px solid #fcd34d;\n}\n\n.capital-income-table table {\n  width: 100%;\n  border-collapse: collapse;\n}\n\n.capital-income-table th {\n  padding: 12px 14px;\n  background: linear-gradient(135deg, #fef3c7 0%, #fde68a 100%);\n  font-size: 11px;\n  font-weight: 600;\n  color: #92400e;\n  text-align: left;\n  border-bottom: 1px solid #fcd34d;\n}\n\n.capital-income-table td {\n  padding: 12px 14px;\n  font-size: 13px;\n  border-bottom: 1px solid #fef3c7;\n  vertical-align: middle;\n}\n\n.capital-income-table tr:last-child td {\n  border-bottom: none;\n}\n\n.capital-income-table .td-year {\n  font-weight: 600;\n  color: #78350f;\n  width: 80px;\n}\n\n.capital-income-table .td-acompte {\n  min-width: 160px;\n}\n\n.capital-income-table .td-detail {\n  width: 40px;\n  text-align: center;\n}\n\n.capital-value {\n  font-weight: 500;\n  color: #334155;\n}\n\n.capital-value.neg {\n  color: #dc2626;\n}\n\n.capital-value.pos {\n  color: #059669;\n}\n\n.capital-value.neutral {\n  color: #9ca3af;\n}\n\n.capital-value.highlight {\n  color: #059669;\n  font-weight: 700;\n  font-size: 14px;\n}\n\n.acompte-detail {\n  display: block;\n  font-size: 10px;\n  color: #9ca3af;\n  margin-top: 2px;\n}\n\n/* Tax reminder at bottom */\n.capital-tax-reminder {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  padding: 12px 14px;\n  background: white;\n  border-radius: 8px;\n  margin-top: 12px;\n  border: 1px solid #fcd34d;\n}\n\n.tax-badge {\n  display: flex;\n  align-items: center;\n  gap: 6px;\n  padding: 6px 12px;\n  background: linear-gradient(135deg, #f59e0b 0%, #d97706 100%);\n  color: white;\n  border-radius: 6px;\n  font-size: 12px;\n  font-weight: 600;\n}\n\n.tax-hint {\n  font-size: 12px;\n  color: #78350f;\n}\n\n/* ===================== DIVIDEND POPOVER STYLES ===================== */\n\n.dividend-popover {\n  width: 600px;\n}\n\n.dividend-header {\n  background: linear-gradient(135deg, #f59e0b 0%, #d97706 100%);\n}\n\n.dividend-tax-badge-large {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  padding: 14px 16px;\n  background: linear-gradient(135deg, #fef3c7 0%, #fde68a 100%);\n  border: 1px solid #fcd34d;\n  border-radius: 8px;\n  margin-bottom: 20px;\n}\n\n.dividend-tax-badge-large .badge-icon {\n  font-size: 24px;\n}\n\n.dividend-tax-badge-large .badge-text {\n  font-size: 15px;\n  font-weight: 600;\n  color: #92400e;\n}\n\n/* Timeline styles */\n.dividend-timeline {\n  margin-bottom: 20px;\n}\n\n.timeline-title {\n  font-size: 14px;\n  font-weight: 600;\n  color: #334155;\n  margin-bottom: 14px;\n  padding-bottom: 8px;\n  border-bottom: 1px solid #e2e8f0;\n}\n\n.timeline-step {\n  display: flex;\n  gap: 14px;\n  padding: 14px 0;\n  border-bottom: 1px solid #f1f5f9;\n}\n\n.timeline-step:last-child {\n  border-bottom: none;\n}\n\n.step-marker {\n  width: 36px;\n  height: 36px;\n  background: linear-gradient(135deg, #f59e0b 0%, #d97706 100%);\n  color: white;\n  border-radius: 50%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-size: 12px;\n  font-weight: 700;\n  flex-shrink: 0;\n}\n\n.step-content {\n  flex: 1;\n}\n\n.step-title {\n  font-size: 13px;\n  font-weight: 600;\n  color: #1e293b;\n  margin-bottom: 8px;\n}\n\n.step-detail {\n  display: flex;\n  justify-content: space-between;\n  font-size: 12px;\n  color: #475569;\n  margin-bottom: 4px;\n  padding: 4px 8px;\n  border-radius: 4px;\n}\n\n.step-detail.highlight-neg {\n  background: #fef2f2;\n  color: #dc2626;\n}\n\n.step-detail.highlight-pos {\n  background: #ecfdf5;\n  color: #059669;\n}\n\n.step-detail.neutral {\n  background: #f8fafc;\n  color: #64748b;\n}\n\n.step-detail.info {\n  background: #f0f9ff;\n  color: #0369a1;\n  font-style: italic;\n}\n\n.step-value {\n  font-weight: 600;\n}\n\n.step-breakdown {\n  display: flex;\n  gap: 16px;\n  font-size: 11px;\n  color: #64748b;\n  padding: 4px 8px;\n  margin-bottom: 4px;\n}\n\n.step-result {\n  display: flex;\n  justify-content: space-between;\n  font-size: 12px;\n  color: #059669;\n  font-weight: 600;\n  padding: 6px 10px;\n  background: #ecfdf5;\n  border-radius: 4px;\n  margin-top: 6px;\n}\n\n.step-formula {\n  font-size: 11px;\n  color: #64748b;\n  padding: 4px 8px;\n  background: #f8fafc;\n  border-radius: 4px;\n  font-family: 'Monaco', 'Menlo', monospace;\n  margin-top: 4px;\n}\n\n/* Summary section */\n.dividend-summary {\n  background: linear-gradient(135deg, #f59e0b 0%, #d97706 100%);\n  border-radius: 10px;\n  padding: 16px;\n  color: white;\n}\n\n.summary-title {\n  font-size: 14px;\n  font-weight: 600;\n  margin-bottom: 12px;\n  padding-bottom: 8px;\n  border-bottom: 1px solid rgba(255, 255, 255, 0.3);\n}\n\n.summary-row {\n  display: flex;\n  justify-content: space-between;\n  font-size: 13px;\n  margin-bottom: 6px;\n}\n\n.summary-row.neg {\n  opacity: 0.9;\n}\n\n.summary-row.total {\n  margin-top: 8px;\n  padding-top: 8px;\n  border-top: 1px solid rgba(255, 255, 255, 0.3);\n  font-size: 15px;\n  font-weight: 700;\n}\n\n.summary-rate {\n  margin-top: 10px;\n  font-size: 11px;\n  opacity: 0.85;\n  text-align: center;\n  padding: 6px 10px;\n  background: rgba(255, 255, 255, 0.15);\n  border-radius: 4px;\n}\n\n/* ===================== CAPITAL INCOME OPTIONS SECTION ===================== */\n\n.person-edit-page .capital-income-options {\n  background: #f8fafc;\n  border: 1px solid #e2e8f0;\n  border-radius: 10px;\n  padding: 16px 20px;\n  margin-bottom: 20px;\n}\n\n.person-edit-page .capital-income-options .options-header {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  margin-bottom: 14px;\n}\n\n.person-edit-page .capital-income-options .options-icon {\n  font-size: 18px;\n}\n\n.person-edit-page .capital-income-options .options-title {\n  font-size: 14px;\n  font-weight: 600;\n  color: #1e293b;\n}\n\n/* Two-column grid for tax options */\n.person-edit-page .capital-income-options .tax-options-grid {\n  display: grid;\n  grid-template-columns: 1fr 1fr;\n  gap: 12px;\n  margin-bottom: 14px;\n}\n\n.person-edit-page .capital-income-options .tax-option-card {\n  display: flex;\n  align-items: flex-start;\n  gap: 10px;\n  padding: 12px 14px;\n  background: white;\n  border: 2px solid #e2e8f0;\n  border-radius: 8px;\n  cursor: pointer;\n  transition: all 0.15s ease;\n}\n\n.person-edit-page .capital-income-options .tax-option-card:hover {\n  border-color: #f59e0b;\n  background: #fffbeb;\n}\n\n.person-edit-page .capital-income-options .tax-option-card.selected {\n  border-color: #f59e0b;\n  background: linear-gradient(135deg, #fffbeb 0%, #fef3c7 100%);\n  box-shadow: 0 2px 8px rgba(245, 158, 11, 0.15);\n}\n\n.person-edit-page .capital-income-options .tax-option-card input[type=\"radio\"] {\n  display: none;\n}\n\n.person-edit-page .capital-income-options .option-content {\n  flex: 1;\n}\n\n.person-edit-page .capital-income-options .option-title {\n  font-size: 13px;\n  font-weight: 600;\n  color: #1e293b;\n  margin-bottom: 4px;\n}\n\n.person-edit-page .capital-income-options .option-bullet {\n  color: #94a3b8;\n  margin-right: 4px;\n}\n\n.person-edit-page .capital-income-options .tax-option-card.selected .option-bullet {\n  color: #f59e0b;\n}\n\n.person-edit-page .capital-income-options .option-default {\n  font-weight: 400;\n  color: #64748b;\n  font-size: 11px;\n}\n\n.person-edit-page .capital-income-options .option-case {\n  font-weight: 400;\n  color: #64748b;\n  font-size: 11px;\n}\n\n.person-edit-page .capital-income-options .option-description {\n  font-size: 11px;\n  color: #64748b;\n  line-height: 1.5;\n  padding-left: 16px;\n}\n\n.person-edit-page .capital-income-options .option-detail {\n  color: #059669;\n  font-style: italic;\n}\n\n/* Info note at bottom */\n.person-edit-page .capital-income-options .tax-info-note {\n  display: flex;\n  align-items: flex-start;\n  gap: 8px;\n  padding: 10px 12px;\n  background: #e0f2fe;\n  border-radius: 6px;\n  border: 1px solid #bae6fd;\n}\n\n.person-edit-page .capital-income-options .tax-info-note .info-icon {\n  font-size: 14px;\n  flex-shrink: 0;\n}\n\n.person-edit-page .capital-income-options .tax-info-note .info-text {\n  font-size: 11px;\n  color: #0369a1;\n  line-height: 1.5;\n}\n\n.person-edit-page .capital-income-options .tax-info-note strong {\n  font-weight: 600;\n}\n\n/* ===================== DIVIDEND TABLE COLUMNS ===================== */\n\n/* Column header indicators - show what's editable vs read-only */\n.person-edit-page .source-years-table th {\n  position: relative;\n}\n\n.person-edit-page .source-years-table th .col-label {\n  display: inline;\n}\n\n.person-edit-page .source-years-table th .col-lock-icon,\n.person-edit-page .source-years-table th .col-edit-icon,\n.person-edit-page .source-years-table th .col-help-icon {\n  margin-left: 4px;\n  font-size: 10px;\n  cursor: help;\n  opacity: 0.7;\n  vertical-align: middle;\n}\n\n.person-edit-page .source-years-table th .col-lock-icon {\n  color: #94a3b8;\n}\n\n.person-edit-page .source-years-table th .col-edit-icon {\n  color: #3b82f6;\n}\n\n.person-edit-page .source-years-table th .col-help-icon {\n  color: #f59e0b;\n  font-weight: bold;\n}\n\n.person-edit-page .source-years-table th:hover .col-lock-icon,\n.person-edit-page .source-years-table th:hover .col-edit-icon,\n.person-edit-page .source-years-table th:hover .col-help-icon {\n  opacity: 1;\n}\n\n/* Column header background colors for clarity */\n.person-edit-page .source-years-table th.editable-col {\n  background: linear-gradient(135deg, #eff6ff 0%, #dbeafe 100%);\n}\n\n.person-edit-page .source-years-table th.readonly-col {\n  background: linear-gradient(135deg, #f8fafc 0%, #f1f5f9 100%);\n}\n\n/* Clickable column headers */\n.person-edit-page .source-years-table th.clickable-header {\n  cursor: pointer;\n  transition: background 0.2s;\n}\n\n.person-edit-page .source-years-table th.clickable-header:hover {\n  background: linear-gradient(135deg, #fef3c7 0%, #fde68a 100%) !important;\n}\n\n.person-edit-page .source-years-table th.clickable-header:hover .col-help-icon {\n  transform: scale(1.2);\n  opacity: 1;\n}\n\n/* ===================== HELP MODALS ===================== */\n\n.help-modal-overlay {\n  position: fixed;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background: rgba(0, 0, 0, 0.5);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  z-index: 2000;\n  animation: fadeIn 0.2s ease;\n}\n\n@keyframes fadeIn {\n  from { opacity: 0; }\n  to { opacity: 1; }\n}\n\n.help-modal {\n  background: white;\n  border-radius: 12px;\n  width: 90%;\n  max-width: 600px;\n  max-height: 80vh;\n  overflow: hidden;\n  box-shadow: 0 20px 60px rgba(0, 0, 0, 0.3);\n  animation: slideUp 0.3s ease;\n}\n\n@keyframes slideUp {\n  from { transform: translateY(20px); opacity: 0; }\n  to { transform: translateY(0); opacity: 1; }\n}\n\n.help-modal-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding: 16px 20px;\n  background: linear-gradient(135deg, #3b82f6 0%, #1d4ed8 100%);\n  color: white;\n  font-weight: 600;\n  font-size: 16px;\n}\n\n.help-modal-header button {\n  background: rgba(255, 255, 255, 0.2);\n  border: none;\n  color: white;\n  width: 28px;\n  height: 28px;\n  border-radius: 50%;\n  cursor: pointer;\n  font-size: 18px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.help-modal-header button:hover {\n  background: rgba(255, 255, 255, 0.3);\n}\n\n.help-modal-body {\n  padding: 20px;\n  overflow-y: auto;\n  max-height: calc(80vh - 60px);\n}\n\n.help-section {\n  margin-bottom: 20px;\n  padding-bottom: 16px;\n  border-bottom: 1px solid #e2e8f0;\n}\n\n.help-section:last-child {\n  border-bottom: none;\n  margin-bottom: 0;\n}\n\n.help-section h4 {\n  margin: 0 0 10px 0;\n  font-size: 14px;\n  font-weight: 600;\n  color: #1e293b;\n}\n\n.help-section p {\n  margin: 0 0 8px 0;\n  font-size: 13px;\n  line-height: 1.6;\n  color: #475569;\n}\n\n.help-section ul {\n  margin: 8px 0;\n  padding-left: 20px;\n}\n\n.help-section ul li {\n  font-size: 13px;\n  line-height: 1.6;\n  color: #475569;\n  margin-bottom: 4px;\n}\n\n.help-section .help-note {\n  background: #f1f5f9;\n  border-left: 3px solid #94a3b8;\n  padding: 8px 12px;\n  font-size: 12px;\n  color: #64748b;\n  margin-top: 8px;\n  border-radius: 0 4px 4px 0;\n}\n\n/* PFU highlight */\n.help-section.highlight-pfu {\n  background: linear-gradient(135deg, #eff6ff 0%, #dbeafe 100%);\n  border: 1px solid #93c5fd;\n  border-radius: 8px;\n  padding: 12px 16px;\n  margin: 12px 0;\n}\n\n.help-section.highlight-pfu h4 {\n  color: #1d4ed8;\n}\n\n/* Barème highlight */\n.help-section.highlight-bareme {\n  background: linear-gradient(135deg, #fff7ed 0%, #ffedd5 100%);\n  border: 1px solid #fdba74;\n  border-radius: 8px;\n  padding: 12px 16px;\n  margin: 12px 0;\n}\n\n.help-section.highlight-bareme h4 {\n  color: #c2410c;\n}\n\n/* Warning highlight */\n.help-section.highlight-warning {\n  background: linear-gradient(135deg, #fefce8 0%, #fef9c3 100%);\n  border: 1px solid #fbbf24;\n  border-radius: 8px;\n  padding: 12px 16px;\n  margin: 12px 0;\n}\n\n.help-section.highlight-warning h4 {\n  color: #b45309;\n}\n\n.help-note.warning {\n  background: #fef3c7;\n  border-left: 3px solid #f59e0b;\n  padding: 8px 12px;\n  margin-top: 10px;\n  border-radius: 0 4px 4px 0;\n}\n\n/* Comparison table in help modal */\n.help-comparison-table {\n  width: 100%;\n  border-collapse: collapse;\n  margin-top: 10px;\n  font-size: 12px;\n}\n\n.help-comparison-table th,\n.help-comparison-table td {\n  padding: 8px 12px;\n  text-align: left;\n  border: 1px solid #e2e8f0;\n}\n\n.help-comparison-table th {\n  background: #f8fafc;\n  font-weight: 600;\n  color: #475569;\n}\n\n.help-comparison-table tr:nth-child(even) td {\n  background: #f8fafc;\n}\n\n.help-comparison-table td:last-child {\n  font-weight: 500;\n  color: #059669;\n}\n\n/* Date column */\n.person-edit-page .source-years-table .td-date {\n  width: 100px;\n}\n\n.person-edit-page .source-years-table .date-value {\n  font-size: 11px;\n  color: #64748b;\n}\n\n.person-edit-page .source-years-table .date-input {\n  width: 100px;\n  padding: 4px 6px;\n  border: 1px solid #e2e8f0;\n  border-radius: 4px;\n  font-size: 11px;\n}\n\n/* Dispense column */\n.person-edit-page .source-years-table .td-dispense {\n  width: 60px;\n  text-align: center;\n}\n\n.person-edit-page .dispense-checkbox {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  cursor: pointer;\n}\n\n.person-edit-page .dispense-checkbox input[type=\"checkbox\"] {\n  display: none;\n}\n\n.person-edit-page .dispense-checkbox .checkbox-label {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  width: 24px;\n  height: 24px;\n  border-radius: 50%;\n  font-size: 12px;\n  font-weight: 600;\n  border: 2px solid #e2e8f0;\n  background: white;\n  transition: all 0.15s ease;\n}\n\n.person-edit-page .dispense-checkbox:hover .checkbox-label {\n  border-color: #f59e0b;\n}\n\n.person-edit-page .dispense-checkbox input:checked + .checkbox-label {\n  background: #059669;\n  border-color: #059669;\n  color: white;\n}\n\n.person-edit-page .dispense-checkbox.disabled {\n  cursor: not-allowed;\n  opacity: 0.5;\n}\n\n.person-edit-page .dispense-checkbox.disabled .checkbox-label {\n  background: #fee2e2;\n  border-color: #fecaca;\n  color: #dc2626;\n}\n\n/* Régime column */\n.person-edit-page .source-years-table .th-regime,\n.person-edit-page .source-years-table .th-dispense {\n  font-size: 11px;\n  cursor: help;\n}\n\n.person-edit-page .source-years-table .td-regime {\n  min-width: 70px;\n}\n\n.person-edit-page .source-years-table .regime-select {\n  padding: 4px 6px;\n  border: 1px solid #d1d5db;\n  border-radius: 4px;\n  font-size: 11px;\n  background: white;\n  cursor: pointer;\n  width: 65px;\n}\n\n.person-edit-page .source-years-table .regime-select:focus {\n  outline: none;\n  border-color: #3b82f6;\n  box-shadow: 0 0 0 2px rgba(59, 130, 246, 0.2);\n}\n\n/* Dispense column */\n.person-edit-page .source-years-table .td-dispense {\n  min-width: 100px;\n}\n\n.person-edit-page .dispense-control {\n  display: flex;\n  align-items: center;\n  gap: 4px;\n}\n\n.person-edit-page .dispense-control input[type=\"checkbox\"] {\n  width: 14px;\n  height: 14px;\n  cursor: pointer;\n}\n\n.person-edit-page .dispense-date {\n  padding: 2px 4px;\n  border: 1px solid #d1d5db;\n  border-radius: 3px;\n  font-size: 10px;\n  width: 85px;\n}\n\n.person-edit-page .dispense-date:focus {\n  outline: none;\n  border-color: #3b82f6;\n}\n\n.person-edit-page .dispense-badge {\n  display: inline-block;\n  margin-left: 4px;\n  color: #10b981;\n  font-weight: 600;\n  font-size: 12px;\n}\n\n/* Acompte column */\n.person-edit-page .source-years-table .th-acompte,\n.person-edit-page .source-years-table .th-regul {\n  cursor: help;\n  position: relative;\n}\n\n.person-edit-page .source-years-table .th-acompte:hover::after,\n.person-edit-page .source-years-table .th-regul:hover::after {\n  content: attr(title);\n  position: absolute;\n  top: 100%;\n  left: 50%;\n  transform: translateX(-50%);\n  background: #1e293b;\n  color: white;\n  padding: 8px 12px;\n  border-radius: 6px;\n  font-size: 11px;\n  font-weight: 400;\n  white-space: normal;\n  width: 220px;\n  z-index: 100;\n  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.2);\n}\n\n.person-edit-page .source-years-table .td-acompte .auto-value.neg {\n  color: #dc2626;\n}\n\n.person-edit-page .source-years-table .td-acompte .auto-value.reduced {\n  color: #f59e0b;\n}\n\n/* Régul IR column */\n.person-edit-page .source-years-table .td-regul {\n  text-align: right;\n  min-width: 100px;\n}\n\n.person-edit-page .source-years-table .td-regul .auto-value {\n  font-size: 12px;\n}\n\n.person-edit-page .source-years-table .td-regul .auto-value.neg {\n  color: #dc2626;\n}\n\n.person-edit-page .source-years-table .td-regul .auto-value.pos {\n  color: #059669;\n}\n\n/* Net column highlight */\n.person-edit-page .source-years-table .td-net .auto-value.highlight,\n.person-edit-page .source-years-table .highlight {\n  color: #059669;\n  font-weight: 700;\n}\n\n/* Imposable value (Barème mode) */\n.person-edit-page .source-years-table .td-net .auto-value.imposable-value {\n  color: #f59e0b;\n  font-weight: 600;\n  display: inline-flex;\n  align-items: center;\n  gap: 4px;\n}\n\n.person-edit-page .source-years-table .imposable-badge {\n  display: inline-block;\n  font-size: 8px;\n  font-weight: 700;\n  padding: 1px 4px;\n  background: #fef3c7;\n  color: #b45309;\n  border-radius: 3px;\n  border: 1px solid #f59e0b;\n  vertical-align: middle;\n}\n\n/* Imposable badge in help modal */\n.imposable-badge-inline {\n  display: inline-block;\n  font-size: 10px;\n  font-weight: 700;\n  padding: 2px 5px;\n  background: #fef3c7;\n  color: #b45309;\n  border-radius: 3px;\n  border: 1px solid #f59e0b;\n  vertical-align: middle;\n  margin-left: 4px;\n}\n\n/* DansMaPoche year card - clickable */\n.dansmapoche-year-card.clickable {\n  cursor: pointer;\n  transition: all 0.2s ease;\n}\n\n.dansmapoche-year-card.clickable:hover {\n  transform: translateY(-2px);\n  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);\n}\n\n.dansmapoche-year-card .view-detail-icon {\n  font-size: 12px;\n  margin-left: 6px;\n  opacity: 0.5;\n}\n\n.dansmapoche-year-card:hover .view-detail-icon {\n  opacity: 1;\n}\n\n/* Tax badge in DansMaPoche cards */\n.dansmapoche-year-card .tax-badge {\n  display: inline-block;\n  font-size: 9px;\n  font-weight: 700;\n  padding: 1px 5px;\n  border-radius: 3px;\n  margin-left: 6px;\n  vertical-align: middle;\n}\n\n.dansmapoche-year-card .tax-badge.pfu {\n  background: #dbeafe;\n  color: #1d4ed8;\n  border: 1px solid #93c5fd;\n}\n\n.dansmapoche-year-card .tax-badge.bareme {\n  background: #ffedd5;\n  color: #c2410c;\n  border: 1px solid #fdba74;\n}\n\n/* Dividend row in breakdown */\n.dansmapoche-year-card .breakdown-row.dividend-row {\n  border-top: 1px dashed #e2e8f0;\n  margin-top: 4px;\n  padding-top: 4px;\n}\n\n/* DansMaPoche Breakdown Modal */\n.dmp-breakdown-modal {\n  width: 700px;\n  max-width: 95vw;\n  max-height: 85vh;\n  overflow-y: auto;\n}\n\n.dmp-header {\n  background: linear-gradient(135deg, #059669 0%, #10b981 100%);\n  color: white;\n}\n\n.dmp-section {\n  padding: 12px;\n  border-bottom: 1px solid #e2e8f0;\n}\n\n.dmp-section:last-child {\n  border-bottom: none;\n}\n\n.dmp-section-title {\n  font-weight: 600;\n  font-size: 13px;\n  color: #1e293b;\n  margin-bottom: 10px;\n  display: flex;\n  align-items: center;\n  gap: 8px;\n}\n\n.dmp-detail-row {\n  display: flex;\n  justify-content: space-between;\n  font-size: 12px;\n  padding: 4px 0;\n  color: #64748b;\n}\n\n.dmp-detail-row span:last-child {\n  font-weight: 500;\n  color: #1e293b;\n}\n\n/* Income item in breakdown */\n.dmp-income-item {\n  background: #f8fafc;\n  border-radius: 6px;\n  padding: 8px 10px;\n  margin-bottom: 8px;\n}\n\n.dmp-income-item.dividend {\n  background: #fffbeb;\n  border: 1px solid #fef3c7;\n}\n\n.dmp-income-item .income-label {\n  font-weight: 500;\n  font-size: 12px;\n  color: #1e293b;\n  margin-bottom: 4px;\n}\n\n.dmp-income-item .linked-tag {\n  font-size: 10px;\n  color: #64748b;\n  margin-left: 8px;\n}\n\n.dmp-income-item .income-values {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 8px;\n  font-size: 11px;\n  color: #64748b;\n}\n\n.dmp-income-item .income-values span {\n  background: white;\n  padding: 2px 6px;\n  border-radius: 3px;\n  border: 1px solid #e2e8f0;\n}\n\n/* Calculation rows */\n.dmp-calc-row {\n  display: flex;\n  justify-content: space-between;\n  padding: 6px 0;\n  font-size: 12px;\n  border-bottom: 1px dotted #e2e8f0;\n}\n\n.dmp-calc-row:last-of-type {\n  border-bottom: none;\n}\n\n.dmp-calc-row span:first-child {\n  color: #64748b;\n}\n\n.dmp-calc-row span:last-child {\n  font-weight: 500;\n  color: #1e293b;\n}\n\n.dmp-calc-row span.positive {\n  color: #059669;\n}\n\n.dmp-calc-row.highlight-neg span:last-child {\n  color: #dc2626;\n}\n\n.dmp-calc-row.result {\n  background: #f1f5f9;\n  margin: 8px -10px 0;\n  padding: 8px 10px;\n  border-radius: 4px;\n  font-weight: 600;\n}\n\n.dmp-calc-row.final {\n  background: linear-gradient(135deg, #ecfdf5 0%, #d1fae5 100%);\n  margin: 8px -10px 0;\n  padding: 10px 10px;\n  border-radius: 4px;\n  font-weight: 700;\n  font-size: 14px;\n}\n\n.dmp-calc-row.final span.highlight {\n  color: #059669;\n  font-size: 16px;\n}\n\n.dmp-formula {\n  font-size: 11px;\n  color: #64748b;\n  font-style: italic;\n  text-align: right;\n  padding: 4px 0;\n  border-top: 1px dotted #e2e8f0;\n  margin-top: 4px;\n}\n\n/* Tax badge large */\n.tax-badge-large {\n  font-size: 10px;\n  font-weight: 600;\n  padding: 3px 8px;\n  border-radius: 4px;\n  margin-left: auto;\n}\n\n.tax-badge-large.pfu {\n  background: #dbeafe;\n  color: #1d4ed8;\n  border: 1px solid #93c5fd;\n}\n\n.tax-badge-large.bareme {\n  background: #ffedd5;\n  color: #c2410c;\n  border: 1px solid #fdba74;\n}\n\n/* Summary section */\n.dmp-summary {\n  background: #f0fdf4;\n}\n\n.dmp-monthly {\n  text-align: center;\n  font-size: 13px;\n  color: #059669;\n  font-weight: 500;\n  margin-top: 8px;\n  padding-top: 8px;\n  border-top: 1px dashed #a7f3d0;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
